function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M53.2545 142.55C53.2545 142.55 20.4335 146.045 31.432 149.214C42.4306 152.383 276.467 155.433 268.726 147.118C254.81 132.172 53.2545 142.55 53.2545 142.55Z",
  fill: "#CADAE0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M32.4481 146.687C32.4481 146.687 20.6093 119.992 37.2832 112.322C85.5479 90.1192 58.6045 72.7717 79.8226 46.277C99.2031 22.0767 145.858 8.12914 181.146 21.9359C216.669 35.8343 211.441 67.3031 237.551 71.7871C263.662 76.2711 250.123 112.791 251.573 123.059C253.024 133.326 254.758 121.053 259.109 133.442C263.461 145.83 268.043 146.687 268.043 146.687H32.4481Z",
  fill: "#D8E9F0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M203.898 32.2578C207.94 24.6462 216.025 24.6462 220.068 28.452C224.111 32.2578 224.111 39.8693 220.068 47.4811C217.238 53.1899 209.962 58.8985 203.898 62.7045C197.834 58.8987 190.557 53.1899 187.727 47.4811C183.684 39.8696 183.684 32.2578 187.727 28.452C191.77 24.6462 199.855 24.6462 203.898 32.2578Z",
  fill: "#4DB7E1"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M200.61 49.2942C200.536 49.2942 200.472 49.2426 200.456 49.1699L198.593 40.6711L197.458 43.7548C197.435 43.8169 197.376 43.8582 197.31 43.8582H188.277C188.19 43.8582 188.119 43.7875 188.119 43.7001C188.119 43.6127 188.19 43.542 188.277 43.542H197.2L198.483 40.054C198.507 39.9883 198.567 39.9464 198.642 39.951C198.712 39.9558 198.77 40.0063 198.786 40.0748L200.603 48.3655L203.224 35.2656C203.239 35.1905 203.303 35.1378 203.382 35.1387C203.459 35.1404 203.523 35.1973 203.535 35.2733L205.197 46.3344L206.57 40.5745C206.587 40.5038 206.65 40.4537 206.723 40.453C206.723 40.453 206.724 40.453 206.724 40.453C206.796 40.453 206.859 40.5018 206.877 40.5716L208.158 45.5491L209.265 43.6213C209.293 43.5723 209.345 43.542 209.402 43.542H219.591C219.679 43.542 219.75 43.6127 219.75 43.7001C219.75 43.7875 219.679 43.8582 219.591 43.8582H209.493L208.239 46.0434C208.207 46.0992 208.145 46.1295 208.08 46.1214C208.017 46.1128 207.965 46.0663 207.949 46.0041L206.73 41.2683L205.316 47.2004C205.298 47.274 205.246 47.3313 205.155 47.3216C205.08 47.3183 205.017 47.2621 205.006 47.1872L203.357 36.2131L200.765 49.1669C200.751 49.2402 200.687 49.2934 200.612 49.2938C200.611 49.2942 200.611 49.2942 200.61 49.2942Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M187.606 44.6246C188.147 44.6246 188.586 44.1858 188.586 43.6445C188.586 43.1031 188.147 42.6643 187.606 42.6643C187.065 42.6643 186.626 43.1031 186.626 43.6445C186.626 44.1858 187.065 44.6246 187.606 44.6246Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M219.947 44.6246C220.489 44.6246 220.927 44.1858 220.927 43.6445C220.927 43.1031 220.489 42.6643 219.947 42.6643C219.406 42.6643 218.967 43.1031 218.967 43.6445C218.967 44.1858 219.406 44.6246 219.947 44.6246Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M49.71 117.763C49.636 118.357 49.4269 118.924 49.0507 119.394C47.5696 121.246 48.0954 122.851 48.6508 123.716C49.2062 124.579 49.2211 127.819 47.4306 129.054C45.6418 130.289 44.731 132.171 44.731 133.652V134.887H41.5834L41.6372 134.748C41.6372 134.748 42.6763 131.517 41.4727 130.089C40.2692 128.662 36.3124 126.59 36.0049 124.707C35.6959 122.824 36.34 120.709 36.6807 119.783C36.9398 119.074 35.5733 117.351 35.0533 115.695C34.8958 115.186 34.8163 114.684 34.8883 114.219C35.1976 112.244 36.7696 112.549 36.7696 108.105C36.7696 103.662 38.8378 102.24 42.2948 102.115C45.7498 101.993 46.5514 105.232 46.5514 108.75C46.5514 112.268 46.0887 113.069 47.755 113.625C48.9991 114.039 49.9323 116.017 49.71 117.763Z",
  fill: "#15A8E1"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M42.9467 136.37C42.9467 136.37 43.0069 135.779 43.0871 134.785C43.4117 130.762 44.065 120.123 42.3964 115.192C40.3151 109.042 42.3733 108.166 42.3733 108.166",
  stroke: "#EBF6E7",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M43.1743 119.021C43.1743 119.021 39.3672 117.385 38.377 114.414",
  stroke: "#EBF6E7",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M43.4817 128.192C43.4817 128.192 39.6217 125.968 38.6843 123.585",
  stroke: "#EBF6E7",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M43.4817 124.419C43.4817 124.419 45.9684 121.359 45.9684 120.116",
  stroke: "#EBF6E7",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M42.4771 115.438L44.9638 111.135",
  stroke: "#EBF6E7",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M41.6373 134.747L41.5835 134.886H39.5467C39.5467 134.886 38.93 129.546 35.4122 128.681C31.8941 127.818 30.2278 124.841 31.5238 122.371C32.82 119.903 31.5739 118.909 30.8388 117.983C30.1037 117.057 31.2146 115.387 33.3754 115.139C33.9179 115.078 34.4937 115.307 35.0529 115.694C35.5731 117.35 36.9396 119.073 36.6802 119.783C36.3398 120.708 35.6955 122.823 36.0047 124.706C36.3122 126.589 40.2688 128.661 41.4723 130.089C42.6761 131.516 41.6373 134.747 41.6373 134.747Z",
  fill: "#149ED4"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M51.0303 125.602C51.4931 127.661 52.6024 129.591 50.0563 131.304C47.5103 133.016 47.3458 134.146 47.5085 134.886H44.7312V133.651C44.7312 132.17 45.6422 130.289 47.431 129.054C49.2213 127.819 49.2064 124.579 48.651 123.716C48.0955 122.851 47.5698 121.246 49.0511 119.395C49.4269 118.924 49.6362 118.358 49.7102 117.763C51.0894 116.81 52.6228 116.404 52.6988 119.232C52.8376 124.416 50.5674 123.545 51.0303 125.602Z",
  fill: "#149ED4"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M48.7177 148.218H38.6827L35.4734 134.886H51.3969L48.7177 148.218Z",
  fill: "#4590C4"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M258.107 117.763C258.033 118.357 257.824 118.924 257.448 119.394C255.967 121.246 256.493 122.851 257.048 123.716C257.604 124.579 257.619 127.819 255.828 129.054C254.039 130.289 253.128 132.171 253.128 133.652V134.887H249.981L250.034 134.748C250.034 134.748 251.073 131.517 249.87 130.089C248.666 128.662 244.709 126.59 244.402 124.707C244.093 122.824 244.737 120.709 245.078 119.783C245.337 119.074 243.97 117.351 243.45 115.695C243.293 115.186 243.213 114.684 243.285 114.219C243.595 112.244 245.167 112.549 245.167 108.105C245.167 103.662 247.235 102.24 250.692 102.115C254.147 101.993 254.948 105.232 254.948 108.75C254.948 112.268 254.486 113.069 256.152 113.625C257.396 114.039 258.329 116.017 258.107 117.763Z",
  fill: "#15A8E1"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M251.344 136.37C251.344 136.37 251.404 135.779 251.484 134.785C251.809 130.762 252.462 120.123 250.793 115.192C248.712 109.042 250.77 108.166 250.77 108.166",
  stroke: "#EBF6E7",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M251.572 119.021C251.572 119.021 247.764 117.385 246.774 114.414",
  stroke: "#EBF6E7",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M251.879 128.192C251.879 128.192 248.019 125.968 247.082 123.585",
  stroke: "#EBF6E7",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M251.879 124.419C251.879 124.419 254.366 121.359 254.366 120.116",
  stroke: "#EBF6E7",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M250.874 115.438L253.361 111.135",
  stroke: "#EBF6E7",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M250.035 134.747L249.981 134.886H247.944C247.944 134.886 247.328 129.546 243.81 128.681C240.292 127.818 238.625 124.841 239.921 122.371C241.217 119.903 239.971 118.909 239.236 117.983C238.501 117.057 239.612 115.387 241.773 115.139C242.315 115.078 242.891 115.307 243.45 115.694C243.971 117.35 245.337 119.073 245.078 119.783C244.737 120.708 244.093 122.823 244.402 124.706C244.709 126.589 248.666 128.661 249.87 130.089C251.074 131.516 250.035 134.747 250.035 134.747Z",
  fill: "#149ED4"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M259.428 125.602C259.891 127.661 261 129.591 258.454 131.304C255.908 133.016 255.743 134.146 255.906 134.886H253.129V133.651C253.129 132.17 254.04 130.289 255.829 129.054C257.619 127.819 257.604 124.579 257.049 123.716C256.493 122.851 255.967 121.246 257.449 119.395C257.825 118.924 258.034 118.358 258.108 117.763C259.487 116.81 261.02 116.404 261.096 119.232C261.235 124.416 258.965 123.545 259.428 125.602Z",
  fill: "#149ED4"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M257.115 148.218H247.08L243.871 134.886H259.794L257.115 148.218Z",
  fill: "#4590C4"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M75.3658 79.804L72.8013 77.9585C72.8013 77.9585 72.7134 81.4311 72.7336 82.5931L71.9421 83.0249L72.8718 85.3107C72.9379 86.9688 73.0018 88.8806 73.0018 88.8806L73.9488 87.9589L75.7954 91.1425L72.5314 96.5697L73.7197 98.0181L77.9424 92.4321C78.3019 91.9566 78.4444 91.3515 78.3353 90.7656L76.6769 81.8695C76.5219 81.0378 76.0523 80.2981 75.3658 79.804Z",
  fill: "#F2D7A5"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M74.8707 90.5403L78.6745 89.2463C78.6745 89.2463 77.1646 80.639 76.4278 79.952C75.691 79.2652 74.7668 78.96 74.7668 78.96L72.769 80.7415L72.6282 84.8548L74.8707 90.5403Z",
  fill: "white"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M74.871 90.5405L75.1475 83.9346L73.7898 87.6514L74.871 90.5405Z",
  fill: "#E3E3E3"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M67.3876 120.855L66.656 127.513L65.16 141.135L65.0256 142.362L64.5165 142.181L64.1859 142.067L63.6461 141.875L62.3572 141.421C62.3572 141.421 62.3594 141.35 62.3638 141.218C62.366 141.216 62.366 141.214 62.366 141.212C62.4167 139.889 62.7031 132.585 62.9277 127.019C63.0709 123.489 63.19 120.658 63.2097 120.495L67.3876 120.855Z",
  fill: "#F2D7A5"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M62.3578 141.22L62.308 142.484C62.308 142.484 61.7644 144.129 61.2857 144.498C60.8069 144.866 60.0701 145.345 60.0701 145.345C60.0701 145.345 60.3648 145.787 60.6593 145.787C60.9538 145.787 61.8749 145.713 62.0589 145.603C62.2432 145.492 63.0534 145.485 63.3481 145.083C63.6428 144.682 64.0847 144.866 64.3059 143.687C64.5268 142.509 64.5268 141.919 64.5268 141.919V140.041C64.5268 140.041 63.8638 139.71 63.7533 139.857C63.6428 140.004 62.3578 141.22 62.3578 141.22Z",
  fill: "#F2D7A5"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M65.2092 141.129L64.9032 146.897H64.0856L64.2005 144.387C64.2005 144.387 64.0535 144.506 63.5574 145.37C63.0681 146.222 62.122 146.897 62.122 146.897H58.7618C58.7618 146.897 58.5505 146.708 58.5505 145.99C58.5505 145.28 60.0824 145.078 60.459 145.043H60.4612C60.877 145.126 61.4921 145.234 62.3078 145.124C63.5326 144.958 64.2005 142.522 64.3061 141.232L65.2092 141.129Z",
  fill: "#303030"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M61.7261 143.885C61.7261 143.885 62.3665 143.848 62.7594 144.013C63.1523 144.179 63.6188 144.67 63.6188 144.67L63.8643 144.13C63.8643 144.13 63.3466 143.54 62.7952 143.467C62.2437 143.393 61.8798 143.467 61.8798 143.467L61.7261 143.885Z",
  fill: "#303030"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M64.3061 141.232C64.3061 141.232 63.2653 141.289 62.98 141.293C62.776 141.296 62.3578 141.22 62.3578 141.22L62.3354 141.786C62.3354 141.786 62.9111 141.929 63.5693 141.883C64.2275 141.836 64.5453 141.772 64.5453 141.772V141.441L64.3061 141.232Z",
  fill: "#303030"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M73.5902 141.421L72.3013 141.875L71.7614 142.067L71.4309 142.182L70.9218 142.362L70.7874 141.135L69.2826 127.432L68.5598 120.855L72.7374 120.496C72.7572 120.659 72.8762 123.484 73.0194 127.009C73.2441 132.577 73.5307 139.89 73.5812 141.212C73.5812 141.215 73.5812 141.217 73.5834 141.219C73.588 141.351 73.5902 141.421 73.5902 141.421Z",
  fill: "#F2D7A5"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M73.5891 141.22L73.639 142.484C73.639 142.484 74.1825 144.129 74.6613 144.498C75.1401 144.866 75.8769 145.345 75.8769 145.345C75.8769 145.345 75.5822 145.787 75.2877 145.787C74.9931 145.787 74.0721 145.713 73.888 145.603C73.7038 145.492 72.8936 145.485 72.5989 145.083C72.3041 144.682 71.8623 144.866 71.6411 143.687C71.4199 142.509 71.4202 141.919 71.4202 141.919V140.041C71.4202 140.041 72.0832 139.71 72.1937 139.857C72.3041 140.004 73.5891 141.22 73.5891 141.22Z",
  fill: "#F2D7A5"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M70.738 141.129L71.044 146.897H71.8616L71.7468 144.387C71.7468 144.387 71.8937 144.506 72.3898 145.37C72.8791 146.222 73.8252 146.897 73.8252 146.897H77.1854C77.1854 146.897 77.3967 146.708 77.3967 145.99C77.3967 145.28 75.8648 145.078 75.4882 145.043H75.486C75.0702 145.126 74.4551 145.234 73.6394 145.124C72.4146 144.958 71.7467 142.522 71.6411 141.232L70.738 141.129Z",
  fill: "#303030"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M74.2212 143.884C74.2212 143.884 73.5808 143.848 73.1879 144.013C72.795 144.179 72.3285 144.67 72.3285 144.67L72.083 144.129C72.083 144.129 72.6006 143.54 73.1521 143.466C73.7036 143.393 74.0675 143.466 74.0675 143.466L74.2212 143.884Z",
  fill: "#303030"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M71.6413 141.232C71.6413 141.232 72.682 141.289 72.9673 141.293C73.1714 141.296 73.5895 141.219 73.5895 141.219L73.6119 141.786C73.6119 141.786 73.0363 141.929 72.3781 141.882C71.7199 141.836 71.4021 141.772 71.4021 141.772V141.44L71.6413 141.232Z",
  fill: "#303030"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M63.2097 120.495L67.3873 120.854L66.6557 127.513C65.3082 127.702 64.023 127.542 62.9275 127.02C63.0709 123.49 63.1899 120.658 63.2097 120.495Z",
  fill: "#C99F7F"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M73.0196 127.009C71.9496 127.54 70.6807 127.687 69.2826 127.432L68.5598 120.854L72.7374 120.495C72.7574 120.658 72.8764 123.483 73.0196 127.009Z",
  fill: "#C99F7F"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M67.5594 73.6476C67.5594 73.6476 67.2326 75.4617 65.688 76.4276C64.1434 77.3935 63.8373 78.8768 63.9315 79.784C64.0257 80.6913 65.5898 81.6339 66.7749 81.8223C67.96 82.0108 70.0567 82.8117 70.9283 81.3275C71.8 79.8433 72.5302 78.4615 72.4832 77.9274C72.436 77.3933 72.4694 77.3113 72.0995 76.3569C71.7297 75.4022 71.2296 75.758 71.4135 74.6438C71.5971 73.5295 69.8531 72.3521 69.3541 72.5878C68.8551 72.8232 67.5594 73.6476 67.5594 73.6476Z",
  fill: "#ED7632"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M72.3186 77.5845L69.2411 79.5998L66.9204 77.6645C66.9204 77.6645 68.3064 77.0913 68.0497 75.5629C67.9146 74.7594 67.8033 74.0333 67.8033 74.0333L67.9656 74.3941L71.555 73.8745C71.555 73.8745 71.3194 75.2592 71.3851 76.215C71.3853 76.2218 71.3857 76.231 71.3883 76.2378C71.5553 77.5845 72.3186 77.5845 72.3186 77.5845Z",
  fill: "#F2D7A5"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M71.3852 76.215C71.3855 76.2218 71.3859 76.231 71.3885 76.2378C70.8096 76.5198 70.3023 76.4792 69.6869 76.4407C69.233 76.4139 68.6259 76.0856 68.0499 75.5629C67.9605 74.753 67.8035 74.0333 67.8035 74.0333L67.9658 74.3941L71.5552 73.8745C71.5552 73.8747 71.3196 75.2592 71.3852 76.215Z",
  fill: "#E3B38F"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M72.6912 74.4596C71.4154 75.9227 70.6905 75.8478 69.6593 75.7861C69.0071 75.7463 68.0443 75.0921 67.3039 74.1247C67.3039 74.1247 66.1096 72.5691 69.179 71.1192C72.1867 69.7002 71.5808 68.6184 71.5586 68.5786C71.6071 68.6162 72.5546 69.3741 72.1536 71.4848C72.0148 72.221 72.2792 73.3226 72.6912 74.4596Z",
  fill: "#F2D7A5"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M72.8387 74.2878C72.7879 74.3473 72.7396 74.4046 72.6911 74.4597C72.2791 73.3228 72.0147 72.2211 72.1535 71.4852C72.5545 69.3742 71.607 68.6163 71.5585 68.579C71.5805 68.6187 72.1864 69.7006 69.1789 71.1195C66.1095 72.5695 67.3038 74.125 67.3038 74.125C67.3038 74.125 67.3038 74.125 67.3016 74.125C66.8235 73.5015 66.4378 72.7502 66.2881 71.9457C65.9068 69.8989 67.1474 67.6271 68.0573 67.0012C68.9652 66.3777 70.4149 66.4282 70.4149 66.4282C70.4149 66.4282 72.9092 67.2413 73.0723 67.605C73.2353 67.9662 73.4778 69.3193 73.4778 69.3193C73.4778 69.3193 74.2071 72.6441 72.8387 74.2878Z",
  fill: "#F2D7A5"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M63.4048 97.2476C63.4048 97.2476 61.9953 101.226 61.2554 106.566C60.5157 111.906 59.2334 124.631 59.2334 124.631C59.2334 124.631 63.8302 126.479 68.3746 126.189C73.0037 125.893 76.4228 125.082 76.4228 125.082L73.8945 97.2974L63.4048 97.2476Z",
  fill: "#413E78"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M61.0799 89.1916C61.0529 89.3919 60.7929 91.1785 60.5963 92.5261C60.4753 93.3569 61.0654 94.1222 61.8995 94.2173L62.6658 94.3047L63.3708 88.3774L61.0799 89.1916Z",
  fill: "#F2D7A5"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M66.9207 77.5847L62.7708 80.0183C61.9667 80.4898 61.4164 81.2969 61.271 82.2178L59.9021 91.5384C61.0323 91.2665 62.5979 90.9349 64.2238 90.5282L64.9949 84.3512L66.9207 77.5847Z",
  fill: "white"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M66.9038 77.5461C66.9038 77.5461 68.1996 78.8026 69.4852 78.5968C70.7709 78.3912 72.1701 77.3821 72.1701 77.3821L73.0973 77.923L74.8433 79.0051L74.9267 85.0428C74.9267 85.0428 73.6009 92.5819 73.7478 94.837C73.8833 96.9163 74.0759 98.8222 74.0759 98.8222C74.0759 98.8222 70.4364 99.7466 66.9783 99.7426C64.7935 99.7402 61.9121 98.7264 61.9121 98.7264C61.9121 98.7264 63.9532 90.9317 62.2128 84.1955C61.6855 82.1538 66.9038 77.5461 66.9038 77.5461Z",
  fill: "white"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M61.7651 84.0227L61.3037 84.1824L63.0879 90.7549L64.1306 91.5383C64.1306 91.5383 65.2615 89.6713 65.2142 89.5063C65.167 89.3414 64.8844 86.0669 64.7667 85.9492C64.6489 85.8315 63.8008 84.8999 63.8008 84.8999L61.7651 84.0227Z",
  fill: "#E3E3E3"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M69.6742 80.6386L61.4905 83.0979L64.9392 94.5741L73.1229 92.1148L69.6742 80.6386Z",
  fill: "#D84A61"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M71.6708 87.2942L72.1529 88.8985C72.1529 88.8985 71.4802 89.8951 70.762 90.0719C70.0439 90.2487 64.6957 93.7754 64.6957 93.7754L64.2485 92.2275L71.6708 87.2942Z",
  fill: "#BA4054"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M62.6552 90.9573L69.8253 87.6096L70.3205 89.5901L62.5383 94.3047L62.6552 90.9573Z",
  fill: "#F2D7A5"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M69.485 87.5274L69.6936 86.2629L70.0257 85.5263L70.909 85.0842L71.572 84.8999C72.0941 85.6317 72.337 86.5154 72.3455 87.5274C71.9559 88.3007 71.5308 89.0028 70.9152 89.3219L70.1485 89.6883L69.178 88.6229L69.485 87.5274Z",
  fill: "#F2D7A5"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M73.672 74.2022C73.482 73.7252 72.6912 73.1458 72.6286 71.7297C72.5678 70.3529 70.9406 69.4255 70.8921 69.3879C70.914 69.4277 70.7449 70.2359 69.179 71.1192C66.2225 72.787 67.3039 74.1247 67.3039 74.1247C67.3039 74.1247 67.3039 74.1247 67.3017 74.1247C67.1981 74.0871 64.5038 73.1933 64.9202 70.0358C65.3912 66.4624 66.6407 65.5951 69.179 65.3595C71.7174 65.1238 73.3112 65.8483 74.0489 67.315C75.1856 69.5748 74.0074 70.7795 74.2845 71.73C74.6238 72.8944 74.5542 73.7836 73.672 74.2022Z",
  fill: "#ED7632"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M94.6888 78.7477C93.6302 78.7477 92.7785 77.8795 92.7974 76.821L92.8093 76.2047L92.8376 74.5038L92.8635 73.064L96.1572 72.5347L96.3148 74.092L96.5147 76.0822L96.5736 76.6633C96.686 77.7785 95.8108 78.7477 94.6888 78.7477Z",
  fill: "#FFD2B1"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M96.3144 73.2873C95.9215 73.732 95.3123 74.1577 94.3971 74.2213C93.7714 74.2637 93.2538 74.0356 92.8374 73.6991L92.8633 72.2593L96.157 71.73L96.3144 73.2873Z",
  fill: "#E8BFA1"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M97.6181 67.0946C97.6181 67.0946 98.273 66.2783 98.6051 66.5287C99.1005 66.9022 98.9446 68.957 98.1432 68.9847C97.4821 69.0075 97.4595 68.6915 97.4257 68.4815C97.3919 68.2716 97.3238 67.717 97.369 67.5587C97.4143 67.4001 97.6181 67.0946 97.6181 67.0946Z",
  fill: "#FFD2B1"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M90.719 68.1518C90.719 68.1518 89.6126 67.8237 89.5118 68.5194C89.411 69.2152 90.5778 70.606 90.9434 70.4448C91.3091 70.2836 91.4982 70.1066 91.5177 69.9467C91.5371 69.7868 91.572 69.2773 91.3076 68.9154C91.0434 68.5534 90.719 68.1518 90.719 68.1518Z",
  fill: "#FFD2B1"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M89.7439 65.5208C89.7439 65.5208 90.6083 72.9782 94.27 72.7528C97.4885 72.5547 98.0997 69.6927 97.8683 66.388C97.7729 65.0268 97.6974 63.8572 96.8611 63.4326C96.0248 63.0083 93.2697 63.4157 93.1385 63.4326C93.0074 63.4495 91.8265 63.6024 91.2035 64.1457C90.5802 64.6889 89.7439 65.5208 89.7439 65.5208Z",
  fill: "#FFD2B1"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M94.2599 60.5992C93.4333 60.8017 91.9618 60.7504 90.5181 60.6228C88.7003 60.462 86.3444 62.1069 86.6154 64.4896C86.8691 66.7205 88.3047 67.1534 89.3176 67.2799C90.3305 67.4064 90.2011 68.9988 90.4168 68.468C90.6325 67.9372 89.7918 65.7632 90.7831 65.4599C91.7745 65.1566 91.6577 65.5837 93.0586 65.2875C94.2837 65.0283 95.1689 63.9632 96.074 64.5192C96.979 65.0753 97.1695 65.4498 97.3542 65.7469C97.7262 66.3452 97.8685 67.4077 97.8685 67.4077C97.8685 67.4077 98.3119 66.2534 98.4533 64.5192C98.5552 63.2685 98.2399 61.5166 96.9685 60.9098C95.6967 60.303 94.9219 60.437 94.2599 60.5992Z",
  fill: "#211F5D"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M101.216 77.0158L97.7449 98.1438L90.0099 97.2875L86.6152 77.3546L92.6611 74.1199L92.6493 74.7361C92.6304 75.7947 93.4821 76.6628 94.5406 76.6628C95.6629 76.6628 96.5379 75.6937 96.425 74.5784L96.3661 73.9973L101.216 77.0158Z",
  fill: "#D84A61"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M93.4587 76.5243C93.4587 76.5243 92.6813 77.6444 92.6813 78.0149C92.6813 78.3854 92.6813 78.833 92.6813 78.833L92.0687 78.3355C92.0687 78.3355 92.3514 83.4683 92.9404 84.2837C93.5294 85.0994 94.4637 87.5022 94.4637 87.5022L94.4279 88.4341C94.4279 88.4341 91.6211 85.9473 91.4092 85.7354C91.1973 85.5234 90.043 82.9921 90.043 82.4791C90.043 81.9661 89.6424 78.7385 90.1607 77.8906C90.679 77.0424 91.5269 76.2652 91.6919 76.1472C91.8568 76.0295 92.2284 75.5824 92.396 75.641C92.5635 75.6997 93.0583 75.9116 93.0583 75.9116L93.4587 76.5243Z",
  fill: "#C9455A"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M85.1193 102.485L84.6438 105.208L83.8608 106.537L84.1204 108.139L87.1771 105.759L86.8626 104.49L87.1771 102.485H85.1193Z",
  fill: "#FFD2B1"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M88.3468 105.044L87.1 116.286L81.0539 120.996L80.9928 121.043L80.24 120.817L80.5035 109.838L80.5975 109.779L88.3468 105.044Z",
  fill: "#FFEFE2"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M81.4844 110.064L81.0539 120.996L80.9928 121.043L80.24 120.817L80.5035 109.838L80.5975 109.779L81.4844 110.064Z",
  fill: "#BFB3AA"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "M81.4845 110.064L88.6902 105.651L88.3469 105.044L80.5977 109.779L81.4845 110.064Z",
  fill: "#FFF8F3"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M85.5188 106.155L86.5943 107.321V108.31C86.5943 108.31 86.9685 108.569 87.0744 108.139C87.1805 107.709 87.177 106.578 87.177 106.578L87.1519 105.658L86.0494 105.044L85.5188 106.155Z",
  fill: "#FFD2B1"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "M88.0397 140.453L87.4779 145.093L87.3965 145.759C87.3965 145.759 87.3965 145.759 86.9669 145.787C86.5373 145.816 85.1976 147.33 83.3445 147.845C81.4935 148.361 80.447 147.244 80.447 146.726C80.447 146.664 80.4536 146.605 80.4668 146.552C80.5571 146.151 80.9603 145.942 81.3879 145.867C81.8704 145.781 84.499 143.029 84.499 143.029L84.7083 140.574L88.0397 140.453Z",
  fill: "#646978"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M87.4777 145.094L87.3962 145.759C87.3962 145.759 87.3962 145.759 86.9667 145.787C86.5371 145.816 85.1974 147.33 83.3442 147.846C81.4933 148.361 80.4468 147.244 80.4468 146.726C80.4468 146.664 80.4534 146.605 80.4665 146.552C80.6561 146.735 80.9005 146.911 81.2091 147.056C82.3636 147.598 83.6814 147.433 85.0013 146.585C86.3212 145.737 86.9139 145.113 87.1915 145.124C87.2728 145.126 87.3743 145.113 87.4777 145.094Z",
  fill: "#434A5B"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "M97.1692 140.212L97.7442 144.852L97.8276 145.517C97.8276 145.517 97.8276 145.517 98.2673 145.546C98.707 145.575 100.078 147.088 101.974 147.604C103.868 148.12 104.939 147.003 104.939 146.485C104.939 146.423 104.932 146.363 104.919 146.311C104.826 145.909 104.414 145.7 103.976 145.625C103.483 145.539 100.793 142.787 100.793 142.787L100.579 140.333L97.1692 140.212Z",
  fill: "#646978"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  d: "M97.7444 144.852L97.8278 145.517C97.8278 145.517 97.8278 145.517 98.2675 145.546C98.7072 145.574 100.078 147.088 101.974 147.604C103.868 148.12 104.939 147.002 104.939 146.484C104.939 146.423 104.932 146.363 104.919 146.31C104.725 146.493 104.475 146.669 104.159 146.815C102.977 147.357 101.629 147.192 100.279 146.343C98.9279 145.495 98.3215 144.872 98.0374 144.883C97.9541 144.885 97.8502 144.872 97.7444 144.852Z",
  fill: "#434A5B"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  d: "M95.7032 95.6465L95.582 100.421L95.571 100.82L95.452 105.548L95.4034 105.8L94.1628 112.276L88.3458 142.632C86.6843 143.17 85.1905 143.278 84.1196 142.315C84.1196 142.315 86.6975 116.619 87.9118 104.387C88.0462 103.063 88.1608 101.895 88.2555 100.937C88.4319 99.1584 88.5353 98.0944 88.5353 98.059L95.7032 95.6465Z",
  fill: "#3D4456"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  d: "M101.15 142.301C100.053 142.976 98.6513 142.89 96.9789 142.478L94.1629 112.276L93.7002 107.313L91.9595 107.391L92.0895 105.595L92.2966 102.726L95.5709 100.82L96.06 100.536L101.15 97.5745C101.145 97.6208 101.141 99.5532 101.141 102.592V102.594C101.139 103.433 101.139 104.359 101.139 105.35C101.135 118.161 101.15 142.301 101.15 142.301Z",
  fill: "#3D4456"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  d: "M101.141 102.592V102.594C101.139 103.434 101.139 104.359 101.139 105.351C100.277 105.419 98.865 105.536 96.5537 105.736C96.1592 105.771 95.7758 105.791 95.4035 105.8C94.1785 105.835 93.0657 105.745 92.0897 105.595C90.0031 105.278 88.5378 104.678 87.9121 104.388C88.0465 103.063 88.1612 101.896 88.2558 100.937L89.3289 99.8947L91.9597 99.5554L95.5821 100.421L96.0602 100.536L100.668 101.638L101.141 102.592Z",
  fill: "#333847"
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  d: "M101.997 75.9267L97.4422 74.072C97.4422 74.072 97.4163 82.4729 96.5362 84.2334C95.6562 85.9941 94.4279 88.4341 94.4279 88.4341C94.4279 88.4341 93.4941 86.3716 92.6141 84.6109C91.734 82.8502 91.7081 74.4493 91.7081 74.4493L87.5323 76.1496C86.2947 76.6536 85.5805 77.9569 85.8221 79.2713L87.7089 89.5407C87.7089 89.5407 87.7115 102.811 87.8946 102.909C90.9142 104.515 96.9698 104.49 102.034 103.642C102.238 103.608 101.441 89.1632 101.441 89.1632L103.402 78.4912C103.601 77.4116 103.014 76.3409 101.997 75.9267Z",
  fill: "#5A6480"
});

var _ref77 = /*#__PURE__*/React.createElement("path", {
  d: "M85.7757 78.3357L85.5906 91.9534L83.8608 102.972C83.8608 102.972 84.8702 103.658 85.7757 103.734C86.6812 103.809 87.7912 103.84 87.7912 103.84L89.3283 90.0691L88.9093 80.1089L85.7757 78.3357Z",
  fill: "#5A6480"
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  d: "M92.8477 72.9463L91.3451 74.5976C91.2386 75.475 91.7 76.7778 92.4135 78.0149C92.7263 77.0925 93.1657 76.3941 93.8283 76.0908C93.6722 76.1501 92.6936 74.6398 92.8433 74.1744C92.9187 73.9405 92.8477 72.9463 92.8477 72.9463Z",
  fill: "white"
});

var _ref79 = /*#__PURE__*/React.createElement("path", {
  d: "M96.2796 72.9463L97.6579 74.2262C97.7645 75.1036 97.3832 76.7778 96.6697 78.0149C96.3569 77.0925 95.9175 76.3941 95.2549 76.0908C95.411 76.1501 96.3943 74.5374 96.2445 74.0721C96.1692 73.8384 96.2796 72.9463 96.2796 72.9463Z",
  fill: "white"
});

var _ref80 = /*#__PURE__*/React.createElement("path", {
  d: "M102.75 96.7662C102.75 96.7662 102.169 97.7826 101.845 97.8391C101.522 97.8955 100.133 99.126 100.133 99.126C100.133 99.126 98.7835 100.495 100.858 99.6331C101.045 99.5552 101.763 99.0334 101.541 101.523C101.496 102.031 102.521 103.992 102.511 103.329C102.494 102.182 102.952 101.209 102.794 100.776C102.636 100.344 103.145 99.2607 103.45 98.9901C103.754 98.7195 104.427 97.1642 104.427 97.1642L103.209 95.6458L102.75 96.7662Z",
  fill: "#FFD2B1"
});

var _ref81 = /*#__PURE__*/React.createElement("path", {
  d: "M102.952 77.0159H101.039L100.274 83.9345L100.234 84.2851L101.839 87.0092L103.878 90.4746L102.391 96.7981L102.181 96.9492C102.328 97.5375 103.202 99.2914 104.02 99.6799L107.214 90.0459C107.419 89.4248 107.41 88.7536 107.188 88.1383C106.169 85.3034 103.201 77.0995 102.952 77.0159Z",
  fill: "#5A6480"
});

var _ref82 = /*#__PURE__*/React.createElement("path", {
  d: "M100.274 83.9346L101.839 87.0095L100.234 84.2851L100.274 83.9346Z",
  fill: "#5A6480"
});

var _ref83 = /*#__PURE__*/React.createElement("path", {
  d: "M104.782 90.7267L104.604 91.2749L103.232 95.5048L102.385 97.3412C102.385 97.3412 102.235 97.0959 102.19 96.9141L103.721 90.4023L101.682 86.937L101.851 82.6399L104.253 89.0168L104.363 89.3697L104.782 90.7267Z",
  fill: "#444B60"
});

var _ref84 = /*#__PURE__*/React.createElement("path", {
  d: "M87.791 87.4783L87.86 91.7541L87.9606 100.406C87.9606 100.406 88.9666 90.8486 88.9666 90.6977C88.9666 90.5469 87.791 81.1902 87.791 81.1902V87.4783V87.4783Z",
  fill: "#444B60"
});

var _ref85 = /*#__PURE__*/React.createElement("path", {
  d: "M101.569 88.4668L100.033 90.7985L98.8262 92.1568L100.198 91.552L101.457 90.4761L101.569 88.4668Z",
  fill: "#444B60"
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  d: "M95.0129 91.3517C95.2547 91.3517 95.4508 91.1556 95.4508 90.9137C95.4508 90.6719 95.2547 90.4758 95.0129 90.4758C94.771 90.4758 94.575 90.6719 94.575 90.9137C94.575 91.1556 94.771 91.3517 95.0129 91.3517Z",
  fill: "#333848"
});

var _ref87 = /*#__PURE__*/React.createElement("path", {
  d: "M95.0353 95.0592C95.2772 95.0592 95.4733 94.8631 95.4733 94.6213C95.4733 94.3794 95.2772 94.1833 95.0353 94.1833C94.7935 94.1833 94.5974 94.3794 94.5974 94.6213C94.5974 94.8631 94.7935 95.0592 95.0353 95.0592Z",
  fill: "#333848"
});

var _ref88 = /*#__PURE__*/React.createElement("path", {
  d: "M94.6702 90.3118C94.6702 90.3118 94.1704 90.7859 94.1892 90.9935C94.2081 91.201 94.5665 91.5783 94.708 91.6066C94.8494 91.635 94.4717 91.2293 94.4484 91.0785C94.4249 90.9274 94.6702 90.3118 94.6702 90.3118Z",
  fill: "#3D4456"
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  d: "M94.34 94.5398C94.34 94.5398 94.1797 95.1529 94.5286 95.2566C94.8776 95.3603 95.2833 95.2566 95.2833 95.2566C95.2833 95.2566 94.6881 95.266 94.5754 94.9737C94.4628 94.6812 94.34 94.5398 94.34 94.5398Z",
  fill: "#3D4456"
});

var _ref90 = /*#__PURE__*/React.createElement("path", {
  d: "M213.977 79.8841C213.977 79.8841 217.259 77.81 218.351 77.6114C219.444 77.4129 224.662 78.8426 224.662 78.8426C224.662 78.8426 224.619 90.2707 224.662 91.1641C224.706 92.0576 224.596 94.1411 224.596 94.1411L218.556 97.0717C218.556 97.0717 215.658 91.2138 215.788 90.7172C215.919 90.2209 214.859 87.1429 214.768 86.2493C214.678 85.3559 213.977 79.8841 213.977 79.8841Z",
  fill: "#007DA2"
});

var _ref91 = /*#__PURE__*/React.createElement("path", {
  d: "M218.035 99.0847L225.575 100.326C225.575 100.326 227.655 101.17 225.575 114.871C223.496 128.573 224.886 136.417 224.886 136.417H221.212C221.212 136.417 219.883 121.531 219.233 118.247C218.682 115.461 218.035 110.304 218.035 110.304L215.656 99.7798L218.035 99.0847Z",
  fill: "#FFDA4A"
});

var _ref92 = /*#__PURE__*/React.createElement("path", {
  d: "M215.057 100.922L210.5 121.208L211.979 136.417H215.657V121.596L221.078 110.602L219.234 97.9927L215.057 100.922Z",
  fill: "#FFDA4A"
});

var _ref93 = /*#__PURE__*/React.createElement("path", {
  d: "M206.977 84.5877C206.875 84.4636 206.198 82.6891 206.198 82.6891L205.937 82.4552C205.573 82.1304 205.041 82.0812 204.624 82.3344C204.11 82.6473 204.124 82.619 203.913 82.8439C203.693 83.0787 203.234 83.5245 203.187 83.7746C203.134 84.056 203.246 84.5137 203.27 84.7827C203.277 84.8569 203.3 84.9281 203.338 84.9922C203.452 85.1861 203.715 85.5988 203.913 85.6735C203.971 85.6952 204.273 85.6524 204.574 85.6016C204.903 85.5461 205.23 85.4813 205.23 85.4813L206.254 85.8722L206.977 84.5877Z",
  fill: "#F2BF99"
});

var _ref94 = /*#__PURE__*/React.createElement("path", {
  d: "M213.977 79.8853L210.789 89.3052L206.976 84.5878L205.078 85.4331L210.455 92.5606C210.941 93.2056 211.929 93.1437 212.331 92.4429L215.656 86.6484L213.977 79.8853Z",
  fill: "#F2BF99"
});

var _ref95 = /*#__PURE__*/React.createElement("path", {
  d: "M216.015 135.92L215.709 143.974L215.656 144.683C215.656 144.683 213.891 145.203 213.667 145.402C213.444 145.602 211.159 147.488 210.141 147.438C209.125 147.389 207.486 147.215 207.783 146.173C207.816 146.056 207.865 145.948 207.929 145.847C208.422 145.047 209.742 144.71 210.513 144.137C211.384 143.491 212.351 142.498 212.351 142.498L211.582 135.92H216.015V135.92Z",
  fill: "#FF9501"
});

var _ref96 = /*#__PURE__*/React.createElement("path", {
  d: "M225.659 147.184C224.423 147.889 223.218 147.924 222.052 147.16C221.642 146.891 221.446 146.389 221.579 145.917C221.581 145.904 221.585 145.889 221.59 145.875C221.7 145.527 221.83 145.117 221.944 144.782C222.112 144.289 222.367 143.676 222.367 143.676L220.712 135.623L225.575 135.275L225.084 143.515C225.084 143.515 225.73 144.373 225.853 144.968C225.902 145.201 226.012 145.503 226.126 145.783C226.34 146.303 226.146 146.906 225.659 147.184Z",
  fill: "#FF9501"
});

var _ref97 = /*#__PURE__*/React.createElement("path", {
  d: "M203.913 137L204.087 77.8789H205.26V137H203.913Z",
  fill: "#948071"
});

var _ref98 = /*#__PURE__*/React.createElement("path", {
  d: "M207.303 144.681L205.928 141.333C205.959 141.508 206.404 144.053 206.497 144.702C205.534 144.728 204.457 144.764 203.543 144.818C201.256 144.957 198.116 146.389 198.116 146.389C198.116 146.389 199.164 143.744 199.88 141.846C200.596 139.945 200.815 136.834 200.815 136.834L207.231 136.448C207.231 136.448 207.308 137.115 207.452 138.073C207.594 139.031 209.131 144.653 209.131 144.653C209.131 144.653 208.359 144.661 207.303 144.681Z",
  fill: "#99B779"
});

var _ref99 = /*#__PURE__*/React.createElement("path", {
  d: "M200.114 136.214C200.114 136.214 202.344 135.636 204.451 135.595C206.557 135.553 208.003 135.905 208.003 135.905V137.164C208.003 137.164 205.814 136.958 204.327 137.164C202.84 137.371 200.114 137.715 200.114 137.715V136.214Z",
  fill: "#79604D"
});

var _ref100 = /*#__PURE__*/React.createElement("path", {
  d: "M219.929 78.6292C219.874 79.764 219.325 80.6146 218.005 80.6146C217.086 80.6146 216.817 79.6584 216.8 78.68L216.925 77.6025L217.1 76.1109L219.545 75.5535L219.772 77.3756L219.929 78.6292Z",
  fill: "#F2BF99"
});

var _ref101 = /*#__PURE__*/React.createElement("path", {
  d: "M219.772 77.3756C219.274 77.6423 218.642 77.8074 217.84 77.8052C217.5 77.8052 217.198 77.7325 216.925 77.6025L217.099 76.1109L219.545 75.5535L219.772 77.3756Z",
  fill: "#B58F72"
});

var _ref102 = /*#__PURE__*/React.createElement("path", {
  d: "M213.977 79.8853L210.917 86.9036C210.917 86.9036 210.843 88.4836 211.662 89.3027C212.481 90.1219 213.628 91.4622 213.628 91.4622L215.497 86.0262L214.976 80.888L213.977 79.8853Z",
  fill: "#007DA2"
});

var _ref103 = /*#__PURE__*/React.createElement("path", {
  d: "M215.057 100.923C215.057 100.923 216.013 93.326 215.788 91.9092C215.7 91.3452 215.317 90.6071 214.896 89.7741C214.636 89.2584 214.363 88.7054 214.138 88.1327C213.812 87.313 213.583 86.4515 213.636 85.6053C213.783 83.2211 214.671 79.4709 214.671 79.4709L215.912 78.7305C215.777 79.5987 215.004 81.2138 215.656 82.3288C216.535 83.8292 218.882 83.3974 220.301 81.8924C220.962 81.1918 221.176 79.0655 221.191 77.9592L223.363 78.4771C223.007 80.3324 221.594 83.0469 222.176 87.738C222.348 89.1262 222.79 94.1917 222.79 94.1917C222.79 94.1917 223.921 94.2798 224.597 94.141C225.073 97.0584 226.197 101.589 226.197 101.589L215.057 100.923Z",
  fill: "#FFDA4A"
});

var _ref104 = /*#__PURE__*/React.createElement("path", {
  d: "M215.656 95.533C215.656 95.533 216.586 96.0383 219.096 95.9301C222.795 95.7706 224.757 95.061 224.757 95.061L225.059 96.5948C225.059 96.5948 221.399 97.1744 218.923 97.32C216.962 97.4353 215.52 96.8184 215.52 96.8184L215.656 95.533Z",
  fill: "#F7E9AD"
});

var _ref105 = /*#__PURE__*/React.createElement("path", {
  d: "M224.663 78.8428L228.864 86.7596C229.273 87.5305 229.355 88.4333 229.093 89.2659L226.524 97.4219L224.63 96.3218L226.816 88.8932L224.359 84.8349C223.353 83.4943 222.125 81.4092 224.663 78.8428Z",
  fill: "#F2BF99"
});

var _ref106 = /*#__PURE__*/React.createElement("path", {
  d: "M224.836 95.8102C224.836 95.8102 224.191 95.5842 223.578 96.2137C222.965 96.8431 222.997 97.3917 223.691 98.0694C224.384 98.7472 225.256 99.3604 225.385 99.7638C225.514 100.167 225.682 100.361 226.107 100.087C226.531 99.8123 227.144 99.8607 226.934 98.7957C226.725 97.7306 226.779 97.532 226.607 97.115C226.434 96.6979 224.836 95.8102 224.836 95.8102Z",
  fill: "#F2BF99"
});

var _ref107 = /*#__PURE__*/React.createElement("path", {
  d: "M222.869 83.3827C222.869 83.3827 222.832 80.6696 223.316 79.8853C223.8 79.101 224.662 78.8428 224.662 78.8428L229.244 86.1007C229.244 86.1007 228.715 87.2177 227.263 87.6644C225.81 88.1111 225.438 88.1322 225.438 88.1322L222.869 83.3827Z",
  fill: "#007DA2"
});

var _ref108 = /*#__PURE__*/React.createElement("path", {
  d: "M204.814 81.8105C204.814 81.8105 204.219 82.1119 204.552 82.615C204.885 83.1182 205.312 82.27 205.511 82.6706C205.71 83.0712 206.068 83.0448 206.068 83.0448C206.068 83.0448 206.053 81.9638 205.639 81.6812C205.226 81.3983 204.814 81.8105 204.814 81.8105Z",
  fill: "#F2BF99"
});

var _ref109 = /*#__PURE__*/React.createElement("path", {
  d: "M204.731 83.5127C204.498 83.0417 203.913 83.0452 203.913 83.0452C203.913 83.0452 203.671 83.4539 203.671 83.6658C203.671 83.8777 203.623 84.1369 203.671 84.3491C203.718 84.561 203.812 84.9144 203.812 84.9144L204.07 85.6736L204.684 85.5034L204.731 83.5127Z",
  fill: "#F2BF99"
});

var _ref110 = /*#__PURE__*/React.createElement("path", {
  d: "M220.29 88.6417C220.29 88.6417 217.952 90.1687 217.337 90.0738C216.722 89.9792 216.392 90.2148 215.497 89.9792C215.284 89.924 215.081 89.8514 214.896 89.7743C214.636 89.2586 214.363 88.7056 214.138 88.1328H214.806C214.806 88.1328 216.291 89.4615 217.566 89.0846C218.842 88.7078 220.29 88.6417 220.29 88.6417Z",
  fill: "#E0BF41"
});

var _ref111 = /*#__PURE__*/React.createElement("path", {
  d: "M217.214 106.67L218.738 115.347L217.354 118.153L217.214 106.67Z",
  fill: "#E0BF41"
});

var _ref112 = /*#__PURE__*/React.createElement("path", {
  d: "M215.709 143.974L215.656 144.683C215.656 144.683 213.891 145.204 213.667 145.402C213.444 145.602 211.159 147.488 210.141 147.438C209.125 147.389 207.486 147.215 207.783 146.173C207.816 146.056 207.865 145.948 207.929 145.847C208.028 146.034 208.134 146.272 208.264 146.446C208.546 146.821 209.89 146.849 210.5 146.825C211.108 146.801 212.104 145.906 212.928 145.195C213.752 144.485 213.942 144.516 214.413 144.421C214.735 144.357 215.35 144.119 215.709 143.974Z",
  fill: "#CF7900"
});

var _ref113 = /*#__PURE__*/React.createElement("path", {
  d: "M225.66 147.184C224.424 147.889 223.218 147.924 222.053 147.16C221.643 146.891 221.447 146.389 221.579 145.917C221.905 146.446 222.496 147.067 223.463 147.026C225.131 146.955 225.497 146.768 226.127 145.783C226.341 146.303 226.147 146.906 225.66 147.184Z",
  fill: "#CF7900"
});

var _ref114 = /*#__PURE__*/React.createElement("path", {
  d: "M214.32 72.2873C214.32 72.2873 214.743 77.2829 217.566 77.2913C221.144 77.3016 221.339 73.9651 221.339 73.3447C221.339 72.7241 220.371 69.5967 219.329 69.4478C218.286 69.2989 217.74 68.6783 216.698 69.3237C215.655 69.9687 214.32 72.2873 214.32 72.2873Z",
  fill: "#F2BF99"
});

var _ref115 = /*#__PURE__*/React.createElement("path", {
  d: "M217.398 66.3306C217.398 66.3306 216.896 63.4637 218.757 62.7005C220.619 61.9373 223.356 62.8681 223.598 66.6286C223.84 70.3892 223.151 70.6125 224.286 71.5993C225.422 72.586 225.85 72.5094 225.85 72.5094C225.85 72.5094 224.268 73.4797 222.871 71.4877C221.475 69.4958 222.257 66.2379 220.582 66.7964C218.906 67.3549 218.757 67.3362 218.757 67.3362L217.398 66.3306Z",
  fill: "#211F5D"
});

var _ref116 = /*#__PURE__*/React.createElement("path", {
  d: "M214.225 69.0356C214.225 69.0356 214.198 67.5429 214.672 66.7753C215.146 66.0077 215.238 66.0916 215.238 66.0916C215.238 66.0916 216.759 65.1764 219.031 65.8162C221.302 66.456 221.339 66.8886 221.339 66.8886C221.339 66.8886 221.245 68.1413 220.982 69.1083C220.72 70.0687 214.225 69.0356 214.225 69.0356Z",
  fill: "#FFDA4A"
});

var _ref117 = /*#__PURE__*/React.createElement("path", {
  d: "M218.261 71.2594C218.261 71.2594 217.617 72.4175 216.393 73.1172C215.202 73.798 214.488 75.9011 214.488 75.9011C214.488 75.9011 212.822 75.3549 212.801 72.6246C212.785 70.5413 213.324 69.8345 214.648 68.7837C216.174 67.5716 217.044 67.6928 218.106 67.858C220.272 68.1944 220.942 68.5785 221.513 70.0058C222.127 71.5401 221.799 71.6429 221.786 72.5253C221.775 73.2929 222.332 74.3126 222.332 74.3126C222.332 74.3126 220.441 75.0672 219.279 73.5182C218.534 72.5255 218.261 71.2594 218.261 71.2594Z",
  fill: "#211F5D"
});

var _ref118 = /*#__PURE__*/React.createElement("path", {
  d: "M122.03 139.728V145.212C122.03 145.212 123.096 145.475 123.675 145.742C124.255 146.009 124.595 146.694 125.836 146.618C127.078 146.541 127.688 146.4 127.936 145.56C128.184 144.72 127.105 144.637 125.863 143.797C124.621 142.957 124.575 142.273 124.575 142.273L124.369 139.448L122.03 139.728Z",
  fill: "#333333"
});

var _ref119 = /*#__PURE__*/React.createElement("path", {
  d: "M125.28 102.76L124.604 140.714H121.777L119.461 122.836L117.31 111.221L117.489 105.951L120.07 101.147L125.28 102.76Z",
  fill: "#36D4C6"
});

var _ref120 = /*#__PURE__*/React.createElement("path", {
  d: "M109.319 88.3784C109.086 89.1023 107.923 91.0938 107.923 91.0938L110.768 99.5461C110.768 99.5461 111.395 101.836 111.54 102.479C111.684 103.122 111.926 102.981 111.645 103.988C111.364 104.994 111.447 106.209 111.672 105.957C111.897 105.704 113.583 101.592 113.367 101.155C113.15 100.718 112.57 100.652 112.099 99.2105C111.915 98.6476 111.147 91.1724 111.147 91.1724L111.845 89.8417C111.003 89.8903 110.161 89.4554 109.319 88.3784Z",
  fill: "#B88761"
});

var _ref121 = /*#__PURE__*/React.createElement("path", {
  d: "M115.051 140.331C115.051 140.331 114.717 143.032 114.43 143.343C114.143 143.653 112.853 145.709 112.853 145.996C112.853 146.282 112.853 146.76 112.853 146.76C112.853 146.76 114.263 147.31 115.577 147.047C116.892 146.784 117.31 146.497 117.31 146.497V145.685V143.821V140.128L115.051 140.331Z",
  fill: "#333333"
});

var _ref122 = /*#__PURE__*/React.createElement("path", {
  d: "M127.04 88.0167L127.93 90.0414C128.438 91.1944 128.27 92.5327 127.494 93.5248C127.055 94.0857 126.156 93.8107 126.106 93.1002L125.74 87.9126L127.04 88.0167Z",
  fill: "#B88761"
});

var _ref123 = /*#__PURE__*/React.createElement("path", {
  d: "M113.061 102.464C113.061 102.464 111.272 105.555 112.324 111.099C113.375 116.644 114.478 140.714 114.478 140.714H117.633L122.03 101.995L113.061 102.464Z",
  fill: "#36D4C6"
});

var _ref124 = /*#__PURE__*/React.createElement("path", {
  d: "M112.914 102.759C112.914 102.759 112.254 104.296 112.236 104.701C112.218 105.107 118.738 106.256 121.895 105.667C125.052 105.078 125.224 104.961 125.224 104.961L125.281 102.76L112.914 102.759Z",
  fill: "#31C2B5"
});

var _ref125 = /*#__PURE__*/React.createElement("path", {
  d: "M117.059 78.0229L114.624 78.8511C113.219 79.3295 112.069 80.3604 111.441 81.706L107.923 89.2473C108.718 90.7486 109.854 91.5798 111.416 91.5794L113.86 86.8833L113.674 88.8693L112.236 104.215C112.236 104.215 116.676 105.389 120.07 105.102C123.464 104.815 125.998 103.381 125.998 103.381C125.998 103.381 124.024 92.3169 124.707 91.4331C126.667 88.8979 124.611 79.481 124.611 79.481L120.52 78.0232H117.059V78.0229Z",
  fill: "#36D4C6"
});

var _ref126 = /*#__PURE__*/React.createElement("path", {
  d: "M115.028 84.0647L113.861 86.8835L113.526 90.4501C114.255 88.3328 114.43 86.8167 115.028 84.0647Z",
  fill: "#31C2B5"
});

var _ref127 = /*#__PURE__*/React.createElement("path", {
  d: "M121.769 87.1711C121.843 86.8056 123.551 78.2111 120.423 77.6014C118.619 77.2498 117.519 77.2768 116.857 77.6892C116.429 77.9559 116.178 78.3867 116.068 79.0449C115.831 80.454 115.639 84.1298 115.637 84.1667L115.896 84.1777C115.898 84.1408 116.089 80.4771 116.324 79.0799C116.423 78.4898 116.639 78.1092 117.004 77.8816C117.594 77.5142 118.663 77.4975 120.368 77.83C121.852 78.1193 122.091 80.6106 122.03 82.6498C121.963 84.8993 121.519 87.1069 121.515 87.1289L121.769 87.1711Z",
  fill: "#E8E8E8"
});

var _ref128 = /*#__PURE__*/React.createElement("path", {
  d: "M120.797 87.6861C120.797 88.068 121.141 88.3783 121.564 88.3783C121.989 88.3783 122.333 88.068 122.333 87.6861C122.333 87.3042 121.989 86.9939 121.564 86.9939C121.141 86.9939 120.797 87.3042 120.797 87.6861ZM121.143 87.6861C121.143 87.4753 121.333 87.3062 121.564 87.3062C121.797 87.3062 121.987 87.4753 121.987 87.6861C121.987 87.8969 121.797 88.066 121.564 88.066C121.333 88.066 121.143 87.8969 121.143 87.6861Z",
  fill: "white"
});

var _ref129 = /*#__PURE__*/React.createElement("path", {
  d: "M116.243 87.4366C116.252 87.4366 116.26 87.4362 116.269 87.4351L116.631 87.3945C116.981 87.3551 117.243 87.096 117.254 86.778L117.306 85.2703C117.333 84.486 116.649 83.8131 115.781 83.7701C114.906 83.7261 114.146 84.3323 114.083 85.1194L113.965 86.5933C113.941 86.8955 114.157 87.1746 114.48 87.257L115.035 87.3984C115.145 87.4265 115.259 87.3688 115.29 87.2695C115.321 87.1704 115.257 87.0672 115.148 87.0393L114.593 86.8979C114.458 86.8634 114.367 86.7468 114.377 86.6203L114.496 85.1464C114.543 84.5611 115.111 84.1092 115.758 84.1428C116.404 84.1746 116.912 84.6751 116.892 85.2584L116.84 86.7661C116.836 86.899 116.726 87.0073 116.58 87.0237L116.218 87.0644C116.104 87.0771 116.024 87.1702 116.038 87.2726C116.051 87.3674 116.14 87.4366 116.243 87.4366Z",
  fill: "#DBDBDB"
});

var _ref130 = /*#__PURE__*/React.createElement("path", {
  d: "M124.611 79.481L128.076 88.3784L125.401 89.5492L122.872 82.343L124.611 79.481Z",
  fill: "#36D4C6"
});

var _ref131 = /*#__PURE__*/React.createElement("path", {
  d: "M123.641 85.6005L127.739 92.345C127.932 92.6619 127.905 93.0653 127.672 93.3539L127.124 94.0328C126.717 94.5359 125.925 94.4432 125.646 93.8597L121.824 85.8656C121.822 85.8627 121.823 85.8592 121.825 85.8572L122.283 85.4206C122.689 85.0334 123.349 85.1206 123.641 85.6005Z",
  fill: "#B88761"
});

var _ref132 = /*#__PURE__*/React.createElement("path", {
  d: "M123.508 85.5634L123.626 85.0405C123.692 84.7492 123.655 84.4442 123.522 84.1769L123.024 83.1289C123.024 83.1289 122.685 83.1629 122.723 83.4452C122.76 83.7274 122.872 84.3941 122.872 84.3941C122.872 84.3941 122.191 83.4728 121.544 83.3733C121.26 83.3296 120.184 83.1592 119.885 83.7575C119.586 84.3559 118.977 85.7307 119.479 85.7004C119.828 85.6791 120.243 85.5032 120.571 85.4885C120.836 85.4766 121.093 85.584 121.272 85.7799L122.167 86.4052L123.508 85.5634Z",
  fill: "#B88761"
});

var _ref133 = /*#__PURE__*/React.createElement("path", {
  d: "M120.686 78.7237L118.852 82.1342L116.912 78.8305L117.106 77.4954L117.339 75.8948L120.492 75.2502L120.623 77.5914L120.686 78.7237Z",
  fill: "#B88761"
});

var _ref134 = /*#__PURE__*/React.createElement("path", {
  d: "M120.622 77.5914C119.412 78.1815 118.135 78.1837 117.105 77.4957L117.338 75.8951L120.492 75.2505L120.622 77.5914Z",
  fill: "#8F694C"
});

var _ref135 = /*#__PURE__*/React.createElement("path", {
  d: "M123.145 70.8771C123.145 70.8771 123.36 74.7011 121.448 76.1113C119.536 77.5215 117.242 77.402 115.975 75.2987C114.709 73.1954 114.613 69.8256 114.613 69.8256L114.948 67.7701C114.948 67.7701 117.386 67.2683 117.457 67.2683C117.529 67.2683 120.947 67.8659 120.947 67.8659L123.145 70.8771Z",
  fill: "#B88761"
});

var _ref136 = /*#__PURE__*/React.createElement("path", {
  d: "M115.473 65.4754C115.473 65.4754 115.043 66.2401 113.848 66.4314C113.04 66.5608 112.569 68.2718 112.749 69.0247C112.928 69.7775 112.675 71.0322 112.46 71.5701C112.245 72.1079 113.035 73.506 113.645 73.721C114.254 73.936 115.284 73.8565 115.688 72.98C116.119 72.048 115.091 71.4983 116.047 70.9725C116.449 70.7513 115.76 69.3115 116.118 69.0247C116.477 68.7379 117.035 70.857 118.317 70.649C120.158 70.3503 118.85 72.2537 120.707 72.3936C121.777 72.4742 121.706 73.4636 123.152 73.3459C124.082 73.2701 124.403 72.4692 124.439 72.0032C124.475 71.5371 125.368 71.8211 125.26 71.0682C125.153 70.3154 125.131 70.172 125.267 69.2757C125.404 68.3794 124.436 68.7021 124.507 67.8416C124.579 66.9811 124.563 66.178 123.773 65.5481C122.82 64.7878 122.778 65.4387 121.954 64.4351C121.129 63.4312 119.674 64.5846 119.208 64.1902C118.742 63.7957 117.887 63.7068 116.955 64.2086C115.579 64.9496 115.473 65.4754 115.473 65.4754Z",
  fill: "#241B15"
});

var _ref137 = /*#__PURE__*/React.createElement("path", {
  d: "M120.339 129.611L121.295 109.13L119.574 123.622L120.339 129.611Z",
  fill: "#31C2B5"
});

var _ref138 = /*#__PURE__*/React.createElement("path", {
  d: "M123.968 83.561L124.221 86.556L124.679 87.3086L123.968 83.561Z",
  fill: "#31C2B5"
});

var _ref139 = /*#__PURE__*/React.createElement("path", {
  d: "M169.566 141.708V144.657C169.566 144.657 170.027 144.974 171.474 145.264C172.923 145.552 174.475 144.947 174.475 144.947C174.475 144.947 174.475 144.422 174.475 144.105C174.475 144.096 174.473 144.086 174.47 144.072C174.393 143.659 173.045 141.514 172.738 141.183C172.421 140.84 172.054 137.865 172.054 137.865L170.001 137.68L169.566 141.708Z",
  fill: "#4F4F4F"
});

var _ref140 = /*#__PURE__*/React.createElement("path", {
  d: "M169.566 143.908V144.657C169.566 144.657 170.027 144.974 171.474 145.264C172.923 145.552 174.475 144.947 174.475 144.947C174.475 144.947 174.475 144.422 174.475 144.105C174.475 144.096 174.473 144.086 174.47 144.072C174.108 144.254 173.575 144.451 172.983 144.451C171.886 144.451 170.675 144.451 170.02 144.115C169.842 144.024 169.691 143.959 169.566 143.908Z",
  fill: "#424242"
});

var _ref141 = /*#__PURE__*/React.createElement("path", {
  d: "M163.894 141.708V144.657C163.894 144.657 163.434 144.974 161.987 145.264C160.538 145.552 158.985 144.947 158.985 144.947C158.985 144.947 158.985 144.422 158.985 144.105C158.985 144.096 158.988 144.086 158.99 144.072C159.067 143.659 160.415 141.514 160.722 141.183C161.039 140.84 161.406 137.865 161.406 137.865L163.46 137.68L163.894 141.708Z",
  fill: "#4F4F4F"
});

var _ref142 = /*#__PURE__*/React.createElement("path", {
  d: "M168.838 107.599L167.902 112.647L166.912 117.997L166.756 118.843L166.467 120.394L163.896 140.091C162.81 140.537 161.783 140.61 160.849 140.091L160.785 117.477L160.776 114.071L160.732 98.4398L165.795 96.5007L166.754 98.2856L168.64 101.793L168.838 107.599Z",
  fill: "#4C9ED7"
});

var _ref143 = /*#__PURE__*/React.createElement("path", {
  d: "M173.452 98.2785L173.139 114.361V114.363L173.086 117.025L172.636 140.09C171.811 140.631 170.737 140.517 169.545 140.09L167.042 120.394L166.756 118.845V118.843L166.599 118.008L165.586 112.537L164.671 107.599L164.87 101.793L166.754 98.2851L167.712 96.5002L173.452 98.2785Z",
  fill: "#4C9ED7"
});

var _ref144 = /*#__PURE__*/React.createElement("path", {
  d: "M173.139 114.361V114.364L173.086 117.025C172.061 117.25 170.288 117.609 168.137 117.896C167.745 117.949 167.333 117.982 166.912 117.997C166.809 118.004 166.705 118.006 166.599 118.008C164.424 118.055 162.06 117.704 160.784 117.477L160.775 114.071C161.95 113.41 163.675 112.453 163.79 112.453C163.84 112.453 164.57 112.487 165.585 112.537C166.266 112.568 167.077 112.608 167.901 112.647C170.195 112.76 172.59 112.879 172.59 112.879L173.139 114.361Z",
  fill: "#4085B5"
});

var _ref145 = /*#__PURE__*/React.createElement("path", {
  d: "M173.97 97.8468L175.446 115.498C175.446 115.498 169.571 117.38 165.832 117.065C162.093 116.747 158.275 115.73 158.275 115.73L160.619 96.9697L160.987 94.0237L161.516 89.7954L161.401 87.3451L161.386 87.0277L161.331 85.86L161.324 85.7058L160.884 76.3215L165.44 74.5786L169.204 74.7152L174.26 76.6894L176.274 83.9517L176.688 85.4478L177.1 86.8667L174.39 88.4377L173.784 87.0936L173.236 85.8752L172.905 85.1392L173.667 94.2613L173.97 97.8468Z",
  fill: "#4C9ED7"
});

var _ref146 = /*#__PURE__*/React.createElement("path", {
  d: "M173.969 97.8471C173.738 98.0476 173.352 98.1071 172.967 98.193C172.425 98.312 172.37 99.6627 172.37 99.6627L172.222 99.3741C172.222 99.3741 172 98.7791 172.048 98.5103C172.094 98.2437 172.685 97.6951 173.117 97.5187C173.55 97.3446 173.061 96.8004 173.117 96.5008C173.174 96.201 173.597 94.2798 173.597 94.2798C173.597 94.2798 173.623 94.271 173.667 94.2622L173.969 97.8471Z",
  fill: "#4085B5"
});

var _ref147 = /*#__PURE__*/React.createElement("path", {
  d: "M162.131 99.2019C162.131 99.2019 161.132 97.5956 160.866 97.2099C160.78 97.0843 160.694 97.0248 160.619 96.9697L160.987 94.0237C161.141 95.0989 161.397 96.7604 161.54 96.8221C161.754 96.9167 162.318 97.5536 162.342 97.9547C162.366 98.3537 162.131 99.2019 162.131 99.2019Z",
  fill: "#4085B5"
});

var _ref148 = /*#__PURE__*/React.createElement("path", {
  d: "M176.689 85.4482C176.576 85.5407 176.305 85.7568 175.97 85.9858C175.539 86.281 174.397 86.8606 173.784 87.0942L173.236 85.8758L176.274 83.9521L176.689 85.4482Z",
  fill: "#4085B5"
});

var _ref149 = /*#__PURE__*/React.createElement("path", {
  d: "M166.901 90.4216C168.251 90.576 173.118 87.6801 173.118 87.6801L172.961 85.7747L161.989 85.8454L161.359 86.4368L161.442 88.2138C161.442 88.2138 165.438 90.2543 166.901 90.4216Z",
  fill: "#4085B5"
});

var _ref150 = /*#__PURE__*/React.createElement("path", {
  d: "M160.209 77.4668L156.723 88.6028L159.827 88.52L162.801 78.4744L160.209 77.4668Z",
  fill: "#4C9ED7"
});

var _ref151 = /*#__PURE__*/React.createElement("path", {
  d: "M160.125 87.3809L157.558 85.8824L158.429 83.1196L161.181 84.682L160.125 87.3809Z",
  fill: "#4085B5"
});

var _ref152 = /*#__PURE__*/React.createElement("path", {
  d: "M165.209 76.093L167.229 79.85L169.367 76.2105L169.153 74.7399L168.897 72.9764L165.422 72.2664L165.279 74.8454L165.209 76.093Z",
  fill: "#B88761"
});

var _ref153 = /*#__PURE__*/React.createElement("path", {
  d: "M165.279 74.8453C166.613 75.4956 168.019 75.4978 169.154 74.7397L168.897 72.9764L165.423 72.2661L165.279 74.8453Z",
  fill: "#8F694C"
});

var _ref154 = /*#__PURE__*/React.createElement("path", {
  d: "M162.499 68.8745C162.499 68.8745 162.274 72.871 164.272 74.3448C166.271 75.8185 168.669 75.6937 169.992 73.4956C171.316 71.2974 171.416 67.7756 171.416 67.7756L171.067 65.6275C171.067 65.6275 168.519 65.103 168.444 65.103C168.369 65.103 164.797 65.7274 164.797 65.7274L162.499 68.8745Z",
  fill: "#FFC9A1"
});

var _ref155 = /*#__PURE__*/React.createElement("path", {
  d: "M174.26 76.6907C172.715 76.0362 171.328 74.7991 170.876 73.8971C170.579 73.3072 172.168 72.0328 172.015 70.614C171.912 69.6475 172.637 67.2642 171.683 65.4708C170.732 63.6752 170.082 62.9842 166.631 63.053C163.177 63.1219 163.797 64.0195 162.325 65.9528C160.852 67.8861 162.602 69.716 162.325 70.9239C162.032 72.2028 163.573 73.1974 163.315 73.8971C163.011 74.7218 161.527 75.5621 160.397 76.3222C159.267 77.0801 157.655 82.6547 157.56 83.5538C157.476 84.3405 164.892 88.8295 166.954 88.8675C169.216 88.9092 176.754 84.3732 176.625 83.9985C176.496 83.6258 175.296 77.1319 174.26 76.6907ZM166.954 74.2784C164.514 74.2784 163.686 70.085 163.686 70.085C163.686 70.085 164.785 67.2227 167.093 67.2227C169.834 67.2227 170.463 69.92 170.463 69.92C170.463 69.92 169.786 74.2784 166.954 74.2784Z",
  fill: "#4C5252"
});

var _ref156 = /*#__PURE__*/React.createElement("path", {
  d: "M172.398 81.1099H169.066V83.1194H172.398V81.1099Z",
  fill: "white"
});

var _ref157 = /*#__PURE__*/React.createElement("path", {
  d: "M172.222 81.2603H169.243V82.9693H172.222V81.2603Z",
  stroke: "#9AA6A6",
  strokeWidth: 0.25,
  strokeMiterlimit: 10
});

var _ref158 = /*#__PURE__*/React.createElement("path", {
  d: "M171.003 80.7332H170.462V81.4928H171.003V80.7332Z",
  fill: "#D6D6D6"
});

var _ref159 = /*#__PURE__*/React.createElement("path", {
  d: "M159.491 97.6061V99.1836L160.013 100.823L160.732 101.415C160.732 101.415 161.593 100.607 161.478 99.5106C161.362 98.414 161.439 98.1832 161.69 98.337C161.94 98.4909 162.017 99.1258 162.094 99.1065C162.17 99.0872 162.382 98.3754 162.094 97.9906C161.805 97.6058 161.69 97.2404 161.363 97.2404C161.036 97.2404 160.362 96.2207 160.362 96.2207L159.491 97.6061Z",
  fill: "#FFC9A1"
});

var _ref160 = /*#__PURE__*/React.createElement("path", {
  d: "M174.971 98.162V99.7395L174.449 101.379L173.73 101.971C173.73 101.971 172.869 101.163 172.985 100.067C173.1 98.9699 173.023 98.7391 172.773 98.8929C172.523 99.0468 172.446 99.6817 172.369 99.6624C172.292 99.6431 172.08 98.9313 172.369 98.5465C172.657 98.1617 172.773 97.7963 173.1 97.7963C173.427 97.7963 174.1 96.7766 174.1 96.7766L174.971 98.162Z",
  fill: "#FFC9A1"
});

var _ref161 = /*#__PURE__*/React.createElement("path", {
  d: "M156.723 88.6029L159.131 98.5104C159.925 98.3261 160.593 97.7248 161.209 96.9517L159.827 88.5199L158.596 87.7297L156.723 88.6029Z",
  fill: "#4C9ED7"
});

var _ref162 = /*#__PURE__*/React.createElement("path", {
  d: "M174.158 87.5442L177.1 86.8684L175.702 98.0793C174.639 98.4489 174.254 97.6972 173.597 97.1365L174.158 87.5442Z",
  fill: "#4C9ED7"
});

var _ref163 = /*#__PURE__*/React.createElement("path", {
  d: "M163.894 143.908V144.657C163.894 144.657 163.434 144.974 161.987 145.264C160.538 145.552 158.985 144.947 158.985 144.947C158.985 144.947 158.985 144.422 158.985 144.105C158.985 144.096 158.988 144.086 158.99 144.072C159.353 144.254 159.885 144.451 160.478 144.451C161.574 144.451 162.786 144.451 163.441 144.115C163.618 144.024 163.769 143.959 163.894 143.908Z",
  fill: "#424242"
});

var _ref164 = /*#__PURE__*/React.createElement("path", {
  d: "M163.706 73.7937C163.706 73.7937 164.684 75.1026 165.209 75.1969C165.734 75.2911 165.145 76.0947 165.546 76.058C165.946 76.0213 165.027 76.6004 164.886 75.9576C164.745 75.3146 164.721 75.6209 164.274 75.1261C163.826 74.6313 163.75 74.3487 163.706 74.1837C163.661 74.019 163.706 73.7937 163.706 73.7937Z",
  fill: "#414747"
});

var _ref165 = /*#__PURE__*/React.createElement("path", {
  d: "M170.258 74.2783C170.258 74.2783 169.786 74.9378 169.197 75.197C168.608 75.4562 167.76 75.6918 167.69 75.786C167.619 75.8802 168.232 75.9037 168.491 75.786C168.75 75.6683 169.622 75.6345 169.716 75.3215C169.81 75.0086 170.258 74.2783 170.258 74.2783Z",
  fill: "#414747"
});

var _ref166 = /*#__PURE__*/React.createElement("path", {
  d: "M161.246 76.8296C161.246 76.8296 161.636 78.0133 163.271 78.0133C164.906 78.0133 165.607 77.6775 165.996 77.9426C166.386 78.2077 167.658 78.1369 168.384 78.0133C169.111 77.8897 168.917 78.5841 167.47 78.5195C166.022 78.455 165.373 78.2252 164.569 78.3313C163.764 78.4374 161.324 78.5786 160.909 77.8012C160.494 77.0237 161.169 76.4094 161.169 76.4094L161.246 76.8296Z",
  fill: "#414747"
});

var _ref167 = /*#__PURE__*/React.createElement("path", {
  d: "M173.165 77.0159C173.165 77.0159 173.613 77.8168 172.058 78.2644C170.503 78.712 170.079 79.4659 168.477 79.5129C166.875 79.5602 166.569 79.6072 166.239 79.6779C165.909 79.7486 165.038 79.4422 165.038 79.4422C165.038 79.4422 166.121 80.1725 166.64 80.0075C167.158 79.8426 168.683 79.8661 169.004 79.8426C169.325 79.8191 170.48 79.4185 171.233 79.0416C171.987 78.6648 173.424 78.0523 173.448 77.7931C173.472 77.5342 173.165 77.0159 173.165 77.0159Z",
  fill: "#414747"
});

var _ref168 = /*#__PURE__*/React.createElement("path", {
  d: "M163.002 66.7323C163.002 66.7323 162.625 67.9178 162.86 68.7657C163.096 69.6139 163.284 70.085 163.284 70.085C163.284 70.085 162.971 68.8053 163.033 68.4086C163.096 68.012 163.428 66.2214 163.428 66.2214L163.002 66.7323Z",
  fill: "#414747"
});

var _ref169 = /*#__PURE__*/React.createElement("path", {
  d: "M171.21 66.5675C171.21 66.5675 171.587 67.753 171.352 68.6009C171.116 69.4491 170.927 69.9202 170.927 69.9202C170.927 69.9202 171.24 68.6405 171.178 68.2438C171.116 67.8472 170.783 66.0566 170.783 66.0566L171.21 66.5675Z",
  fill: "#414747"
});

var _ref170 = /*#__PURE__*/React.createElement("path", {
  d: "M186.498 67.9852C186.498 67.9852 185.502 67.5319 185.32 67.9852C185.139 68.4385 185.746 69.8594 186.166 70.1814C186.709 70.5978 187.216 70.1816 187.216 70.1816L186.498 67.9852Z",
  fill: "#E8B087"
});

var _ref171 = /*#__PURE__*/React.createElement("path", {
  d: "M193.987 67.9852C193.987 67.9852 194.983 67.5319 195.165 67.9852C195.346 68.4385 194.739 69.8594 194.319 70.1814C193.776 70.5978 193.269 70.1816 193.269 70.1816L193.987 67.9852Z",
  fill: "#E8B087"
});

var _ref172 = /*#__PURE__*/React.createElement("path", {
  d: "M187.254 74.5353C187.254 74.5353 189.3 73.7616 190.178 73.6746C192.135 73.4811 193.82 74.4035 193.82 74.4035L194.87 75.8476L185.245 77.6744L187.254 74.5353Z",
  fill: "#EF5924"
});

var _ref173 = /*#__PURE__*/React.createElement("path", {
  d: "M173.233 101.146C173.233 101.146 175.56 103.302 177.475 103.643C184.346 104.868 185.688 104.079 185.688 104.079V106.294C181.149 106.716 176.063 106.392 172.493 104.91C172.493 104.91 172.071 103.913 172.071 102.834C172.071 101.755 173.233 101.146 173.233 101.146Z",
  fill: "#CFC18B"
});

var _ref174 = /*#__PURE__*/React.createElement("path", {
  d: "M181.398 103C181.398 103 181.19 103.871 181.398 104.203C181.606 104.536 181.232 104.924 181.066 105.249C180.9 105.574 180.381 105.781 180.309 105.449C180.236 105.117 180.309 104.079 180.309 104.079L179.236 103.933L180.662 103H181.398V103Z",
  fill: "#FFC294"
});

var _ref175 = /*#__PURE__*/React.createElement("path", {
  d: "M179.236 106.359C179.236 106.359 179.239 105.906 179.599 105.906C179.959 105.906 180.967 106.083 181.459 106.133C181.951 106.183 182.173 106.736 181.868 106.764C181.564 106.792 180.485 106.875 180.097 106.764C179.71 106.653 179.236 106.359 179.236 106.359Z",
  fill: "#FFC294"
});

var _ref176 = /*#__PURE__*/React.createElement("path", {
  d: "M180.622 103.311L182.008 102.232L182.952 102.772L182.655 103.685L182.33 104.281L181.459 104.536L180.505 103.664L180.622 103.311Z",
  fill: "#FFC294"
});

var _ref177 = /*#__PURE__*/React.createElement("path", {
  d: "M182.843 77.697L182.229 93.617L185.901 93.0359L185.135 78.9201L182.843 77.697Z",
  fill: "#3D4456"
});

var _ref178 = /*#__PURE__*/React.createElement("path", {
  d: "M182.425 92.6206L180.309 102.834L182.963 104.079L185.97 93.617L182.425 92.6206Z",
  fill: "#3D4456"
});

var _ref179 = /*#__PURE__*/React.createElement("path", {
  d: "M197.979 77.6745L196.818 100.026L184.576 100.15L182.768 78.5357C182.677 77.4523 183.316 76.4398 184.332 76.0551L187.447 74.8761L188.716 74.1591L191.457 73.675L192.624 74.1591L193.774 74.6354L197.679 76.2536C198.433 76.5659 198.053 76.8615 197.979 77.6745Z",
  fill: "#494F60"
});

var _ref180 = /*#__PURE__*/React.createElement("path", {
  d: "M192.005 96.8903V98.1244L196.906 98.3328L197 96.6558L192.005 96.8903Z",
  fill: "#323742"
});

var _ref181 = /*#__PURE__*/React.createElement("path", {
  d: "M184.15 80.8464H189.346L189.88 98.2905H184.42L184.15 80.8464Z",
  fill: "#323742"
});

var _ref182 = /*#__PURE__*/React.createElement("path", {
  d: "M193.773 74.635C193.271 75.6888 192.461 77.3636 190.44 77.3636C188.9 77.3636 187.824 76.0175 187.447 74.876L188.259 74.4178V71.3498L192.536 70.7388L192.621 72.6907L192.689 74.1844L193.773 74.635Z",
  fill: "#FFC294"
});

var _ref183 = /*#__PURE__*/React.createElement("path", {
  d: "M192.622 72.6907C191.995 73.2861 191.198 73.6744 190.178 73.6744C189.402 73.6744 188.772 73.4647 188.26 73.1153V71.3498L192.537 70.7388L192.622 72.6907Z",
  fill: "#E8B087"
});

var _ref184 = /*#__PURE__*/React.createElement("path", {
  d: "M189.469 97.5545H184.222L184.187 96.109L184.15 94.6569C184.128 94.3617 184.105 94.0641 184.088 93.769C184.057 93.2843 184.028 92.7996 184.006 92.3168C183.727 86.5637 182.813 81.5408 182.989 76.376L187.254 74.5352C187.587 76.6305 188.094 78.3205 188.933 80.0063C189.028 83.697 189.131 87.8636 189.29 92.3168C189.308 92.7972 189.325 93.2819 189.345 93.769C189.356 94.0641 189.369 94.3595 189.38 94.6569L189.425 96.109L189.469 97.5545Z",
  fill: "#EF5924"
});

var _ref185 = /*#__PURE__*/React.createElement("path", {
  d: "M189.38 94.657L189.426 96.1093H184.186L184.15 94.657H189.38Z",
  fill: "#FDCA23"
});

var _ref186 = /*#__PURE__*/React.createElement("path", {
  d: "M196.86 101.501H184.527L184.576 100.176L196.818 100.026L196.86 101.501Z",
  fill: "#24231C"
});

var _ref187 = /*#__PURE__*/React.createElement("path", {
  d: "M195.98 140.037L196.206 144.435L196.208 144.463C196.208 144.463 196.217 144.721 196.293 145.232C196.33 145.483 198.891 146.588 199.185 146.664C201.5 147.261 203.379 146.855 203.151 145.64C203.14 145.577 203.128 145.522 203.114 145.469C202.87 144.467 202.359 144.834 201.71 144.401C201.026 143.945 199.851 143.056 199.851 143.056L199.522 140.037H195.98Z",
  fill: "#333333"
});

var _ref188 = /*#__PURE__*/React.createElement("path", {
  d: "M196.206 144.435L196.208 144.463C196.208 144.463 196.217 144.721 196.293 145.232C196.33 145.483 198.891 146.588 199.185 146.664C201.5 147.261 203.379 146.855 203.151 145.639C203.14 145.577 203.128 145.522 203.114 145.469C203.027 145.559 202.893 145.649 202.695 145.734C201.783 146.128 200.54 146.312 199.112 145.808C197.997 145.414 196.717 144.721 196.206 144.435Z",
  fill: "#1A1A1A"
});

var _ref189 = /*#__PURE__*/React.createElement("path", {
  d: "M185.502 139.796L185.276 144.195L185.274 144.222C185.274 144.222 185.265 144.48 185.189 144.991C185.152 145.242 182.591 146.348 182.296 146.424C179.982 147.02 178.103 146.615 178.331 145.399C178.342 145.337 178.354 145.282 178.367 145.229C178.612 144.227 179.123 144.593 179.772 144.16C180.456 143.704 181.631 142.815 181.631 142.815L181.96 139.796H185.502Z",
  fill: "#333333"
});

var _ref190 = /*#__PURE__*/React.createElement("path", {
  d: "M185.276 144.195L185.274 144.223C185.274 144.223 185.265 144.48 185.189 144.992C185.152 145.243 182.591 146.348 182.296 146.424C179.982 147.02 178.103 146.615 178.331 145.399C178.342 145.337 178.354 145.282 178.367 145.229C178.455 145.319 178.589 145.408 178.786 145.494C179.698 145.887 180.942 146.072 182.37 145.567C183.484 145.173 184.765 144.48 185.276 144.195Z",
  fill: "#1A1A1A"
});

var _ref191 = /*#__PURE__*/React.createElement("path", {
  d: "M199.797 141.678C199.772 141.706 199.744 141.735 199.711 141.761C199.041 142.354 196.989 142.581 196.088 142.127H196.086C195.996 142.083 195.918 142.03 195.855 141.973L191.399 107.966H190.126L185.637 141.942C185.567 141.975 185.483 142.006 185.386 142.032C184.476 142.295 182.522 142.277 181.744 141.786C181.662 141.737 181.592 141.68 181.539 141.618L182.81 124.105L183.007 121.382L184.454 101.465L184.492 100.95L184.529 100.427L184.606 99.3521H196.901L196.976 100.436L197.049 101.516L199.797 141.678Z",
  fill: "#473E37"
});

var _ref192 = /*#__PURE__*/React.createElement("path", {
  d: "M196.976 100.437C193.787 100.443 187.345 100.432 184.529 100.428L184.606 99.3525H196.901L196.976 100.437Z",
  fill: "#292420"
});

var _ref193 = /*#__PURE__*/React.createElement("path", {
  d: "M186.17 65.3524C186.17 65.3524 185.557 73.0977 190.084 72.9433C194.931 72.7779 194.426 65.2169 194.426 65.2169L192.632 62.6221C192.632 62.6221 189.66 62.6504 189.541 62.7275C189.421 62.8046 187.905 64.0748 187.905 64.0748L186.17 65.3524Z",
  fill: "#FFC9A1"
});

var _ref194 = /*#__PURE__*/React.createElement("path", {
  d: "M189.105 63.7797C189.105 63.7797 190.537 65.984 189.646 66.0973C188.755 66.2106 186.6 66.9496 186.541 67.3166C186.481 67.6889 186.162 67.8903 185.76 67.8158C185.419 67.7526 184.937 65.9708 185.59 64.7113C186.243 63.452 187.248 62.0225 187.814 62.1029C188.38 62.183 189.105 63.7797 189.105 63.7797Z",
  fill: "#45443B"
});

var _ref195 = /*#__PURE__*/React.createElement("path", {
  d: "M192.788 63.5288C192.788 63.5288 191.721 64.9416 191.897 65.1738C192.072 65.4059 192.356 66.4111 193.265 66.4003C193.913 66.3927 194.003 67.9935 194.205 68.1518C194.556 68.4261 195.273 67.7146 195.354 67.4374C195.538 66.8058 195.121 65.4946 194.656 64.8988C194.192 64.303 192.788 63.5288 192.788 63.5288Z",
  fill: "#45443B"
});

var _ref196 = /*#__PURE__*/React.createElement("path", {
  d: "M195.768 65.6401C195.768 65.9729 195.746 66.299 195.701 66.6117C192.094 66.3385 188.487 66.3385 184.883 66.6117C184.839 66.2988 184.814 65.9726 184.814 65.6401C184.814 65.5433 184.817 65.444 184.823 65.3472C184.825 65.3118 184.825 65.2767 184.83 65.2435C184.85 64.8205 184.909 64.4107 185.002 64.0163C185.621 61.3127 187.754 59.3208 190.292 59.3208C192.828 59.3208 194.964 61.3127 195.58 64.0163C195.675 64.4107 195.735 64.8205 195.752 65.2435C195.757 65.2767 195.757 65.3118 195.759 65.3472C195.765 65.444 195.768 65.5431 195.768 65.6401Z",
  fill: "#FCEE21"
});

var _ref197 = /*#__PURE__*/React.createElement("path", {
  d: "M196.477 66.0654V66.6755C196.219 66.6536 195.959 66.6314 195.701 66.6116C192.094 66.3384 188.487 66.3384 184.883 66.6116C184.623 66.6314 184.365 66.6536 184.107 66.6755V66.065C184.107 65.651 184.412 65.3003 184.822 65.2443C184.825 65.244 184.827 65.2436 184.83 65.2432C188.47 64.7673 192.11 64.7673 195.752 65.2432C195.755 65.2436 195.758 65.244 195.761 65.2445C196.172 65.3005 196.477 65.6514 196.477 66.0654Z",
  fill: "#FCEF37"
});

var _ref198 = /*#__PURE__*/React.createElement("path", {
  d: "M197.371 99.4211C197.371 99.4211 197.153 99.9038 196.434 100.307C195.94 100.584 195.684 100.861 195.627 101.22C195.582 101.504 195.377 101.488 195.866 101.531C196.145 101.556 196.949 100.9 196.949 100.9C196.949 100.9 196.645 101.936 196.725 102.462C196.949 103.917 196.698 104.925 196.811 105.076C196.925 105.228 197.149 105.434 197.396 104.405C197.643 103.376 197.63 102.329 197.915 101.841C198.2 101.354 199.246 100.026 199.246 100.026L198.146 99.353L197.371 99.4211Z",
  fill: "#FFC294"
});

var _ref199 = /*#__PURE__*/React.createElement("path", {
  d: "M198.131 76.5229L195.971 81.9897L200.584 91.2302L197.249 99.3148C197.642 99.9752 198.444 100.372 199.399 100.67L203.42 92.4818C203.943 91.4166 203.997 90.1813 203.57 89.0742L198.131 76.5229Z",
  fill: "#3D4456"
});

var _ref200 = /*#__PURE__*/React.createElement("path", {
  d: "M197.205 92.3851C197.177 92.8676 197.146 93.3501 197.113 93.8372C197.093 94.1546 197.071 94.4739 197.049 94.7935L197.011 96.2456L196.976 97.5545H191.54L191.582 96.2456L191.626 94.7935C191.642 94.4739 191.657 94.1546 191.673 93.8372C191.695 93.3503 191.717 92.8654 191.739 92.3851C191.939 87.9121 192.08 83.7082 192.093 80.0041C192.966 78.4859 193.437 76.585 193.82 74.4036L198.131 76.5229C198.655 79.9632 197.549 86.6693 197.205 92.3851Z",
  fill: "#EF5924"
});

var _ref201 = /*#__PURE__*/React.createElement("path", {
  d: "M197.048 94.7942L197.011 96.2466H191.582L191.626 94.7942H197.048Z",
  fill: "#FDCA23"
});

var _ref202 = /*#__PURE__*/React.createElement("path", {
  d: "M189.346 93.7688H184.088C184.057 93.2841 184.029 92.7994 184.007 92.3167H189.291C189.308 92.7972 189.326 93.2819 189.346 93.7688Z",
  fill: "#FDCA23"
});

var _ref203 = /*#__PURE__*/React.createElement("path", {
  d: "M197.205 92.3853C197.177 92.8678 197.146 93.3503 197.113 93.8374H191.673C191.695 93.3505 191.717 92.8656 191.739 92.3853H197.205Z",
  fill: "#FDCA23"
});

var _ref204 = /*#__PURE__*/React.createElement("path", {
  d: "M189.584 64.8865L189.488 59.9701C189.473 59.2168 189.683 58.583 189.948 58.583H190.803C191.044 58.583 191.239 59.1064 191.262 59.7679C191.264 59.8326 191.265 59.8985 191.263 59.9655L191.173 64.8865H189.584V64.8865Z",
  fill: "#FCE014"
});

var _ref205 = /*#__PURE__*/React.createElement("path", {
  d: "M195.76 65.3465C192.014 64.7515 188.362 64.7166 184.823 65.3465C184.84 64.8888 184.903 64.4441 185.002 64.0158C188.421 63.3471 191.954 63.3855 195.581 64.0158C195.683 64.4443 195.743 64.8888 195.76 65.3465Z",
  fill: "#FCF597"
});

var _ref206 = /*#__PURE__*/React.createElement("path", {
  d: "M194.441 61.519C194.441 61.519 194.769 62.208 193.637 62.9663C193.236 63.2349 192.109 63.5958 192.109 63.5958L195.43 63.9979C195.496 64.006 195.546 63.9382 195.518 63.8773C195.314 62.9701 194.951 62.1867 194.441 61.519Z",
  fill: "#E3D61E"
});

var _ref207 = /*#__PURE__*/React.createElement("path", {
  d: "M150.002 140.206L150.245 144.932L150.247 144.962C150.247 144.962 150.257 145.239 150.339 145.789C150.378 146.058 153.13 147.246 153.447 147.328C155.934 147.969 157.954 147.533 157.709 146.227C157.696 146.16 157.684 146.1 157.669 146.043C157.407 144.967 156.857 145.36 156.16 144.895C155.424 144.405 154.163 143.45 154.163 143.45L153.809 140.206H150.002V140.206Z",
  fill: "#333333"
});

var _ref208 = /*#__PURE__*/React.createElement("path", {
  d: "M150.245 144.932L150.247 144.962C150.247 144.962 150.257 145.239 150.339 145.789C150.378 146.058 153.13 147.246 153.447 147.328C155.934 147.969 157.954 147.533 157.709 146.227C157.696 146.16 157.684 146.101 157.669 146.044C157.575 146.14 157.432 146.237 157.219 146.328C156.239 146.751 154.902 146.949 153.368 146.408C152.17 145.984 150.794 145.239 150.245 144.932Z",
  fill: "#1A1A1A"
});

var _ref209 = /*#__PURE__*/React.createElement("path", {
  d: "M138.743 139.947L138.501 144.674L138.498 144.703C138.498 144.703 138.488 144.98 138.407 145.53C138.367 145.8 135.615 146.988 135.298 147.069C132.811 147.71 130.792 147.275 131.037 145.968C131.049 145.901 131.062 145.842 131.076 145.785C131.339 144.708 131.888 145.102 132.586 144.637C133.321 144.147 134.583 143.191 134.583 143.191L134.937 139.947H138.743V139.947Z",
  fill: "#333333"
});

var _ref210 = /*#__PURE__*/React.createElement("path", {
  d: "M138.5 144.674L138.497 144.703C138.497 144.703 138.487 144.981 138.406 145.53C138.366 145.8 135.614 146.988 135.297 147.069C132.81 147.71 130.791 147.275 131.036 145.968C131.048 145.902 131.061 145.842 131.075 145.785C131.169 145.882 131.313 145.978 131.526 146.07C132.506 146.493 133.842 146.691 135.376 146.149C136.574 145.726 137.95 144.981 138.5 144.674Z",
  fill: "#1A1A1A"
});

var _ref211 = /*#__PURE__*/React.createElement("path", {
  d: "M154.104 141.97C153.446 142.737 150.671 143.014 149.868 142.287L145.081 105.743H143.712L138.889 142.254C138.027 142.666 135.143 142.673 134.485 141.906L135.851 123.087L136.062 120.16L137.781 96.4871H150.993L154.104 141.97Z",
  fill: "#858599"
});

var _ref212 = /*#__PURE__*/React.createElement("path", {
  d: "M149.446 119.599L148.585 122.81C148.585 122.81 150.08 123.402 151.443 123.198C152.807 122.994 152.794 122.81 152.794 122.81L152.433 119.3L149.446 119.599Z",
  fill: "#6F6F80"
});

var _ref213 = /*#__PURE__*/React.createElement("path", {
  d: "M140.561 123.047C140.561 123.047 139.169 123.35 137.928 123.478C136.893 123.582 136.088 123.212 135.851 123.087L136.062 120.16H140.156L140.561 123.047Z",
  fill: "#6F6F80"
});

var _ref214 = /*#__PURE__*/React.createElement("path", {
  d: "M137.021 99.022H151.166L150.8 97.7302H137.69L137.021 99.022Z",
  fill: "#263029"
});

var _ref215 = /*#__PURE__*/React.createElement("path", {
  d: "M137.021 97.6973C137.502 97.7713 151.444 97.6973 151.444 97.6973L150.565 74.0017L147.644 70.6791L143.735 70.0508L138.185 73.2379L137.021 97.6973Z",
  fill: "#D84A61"
});

var _ref216 = /*#__PURE__*/React.createElement("path", {
  d: "M139.906 73.4886L141.401 71.4932L142.433 74.4112L142.587 75.201C142.587 75.201 142.023 75.5146 141.933 75.6229C141.842 75.7311 141.222 75.201 141.222 75.201C141.222 75.201 141.259 85.4967 141.222 86.6561C141.185 87.8155 141.006 96.7133 141.006 96.7133V97.7306H139.677L138.5 88.1111L138.766 74.6522L139.906 73.4886Z",
  fill: "#C9455A"
});

var _ref217 = /*#__PURE__*/React.createElement("path", {
  d: "M141.006 121.491C141.006 121.491 138.92 122.021 136.413 122.1C135.352 122.133 134.483 121.872 133.832 121.564C132.946 121.143 132.465 120.629 132.465 120.629L136.24 83.9544V83.952L137.123 75.3664L140.922 70.8723C140.922 70.8723 140.667 77.2889 140.514 79.3395C140.362 81.3901 140.362 97.1122 139.907 100.759C139.45 104.403 141.006 121.491 141.006 121.491Z",
  fill: "#FAFAFA"
});

var _ref218 = /*#__PURE__*/React.createElement("path", {
  d: "M140.821 72.0014C140.806 72.0169 141.567 73.5883 142.433 74.4554C143.633 75.6571 144.02 76.1761 144.02 76.1761L144.046 74.8597C144.046 74.8597 141.603 73.3639 141.4 71.4927C141.266 70.2585 140.82 71.2142 140.82 71.2142L140.821 72.0014Z",
  fill: "#2E2E2E"
});

var _ref219 = /*#__PURE__*/React.createElement("path", {
  d: "M156.001 120.629C156.001 120.629 155.466 121.202 154.481 121.633C154.474 121.635 154.469 121.638 154.462 121.64C153.832 121.915 153.022 122.128 152.052 122.099C149.544 122.021 147.458 121.491 147.458 121.491C147.458 121.491 149.014 104.402 148.557 100.758C148.102 97.112 148.102 81.3897 147.951 79.3393C147.799 77.2887 147.458 70.4548 147.458 70.4548L151.344 75.3662L152.019 81.9297V81.9346C152.021 81.937 152.021 81.937 152.021 81.9394L156.001 120.629Z",
  fill: "#FAFAFA"
});

var _ref220 = /*#__PURE__*/React.createElement("path", {
  d: "M147.645 72.0014C147.659 72.0169 146.898 73.5883 146.032 74.4554C144.832 75.6571 144.445 76.1761 144.445 76.1761L144.419 74.8597C144.419 74.8597 146.862 73.3639 147.065 71.4927C147.199 70.2585 147.645 71.2142 147.645 71.2142L147.645 72.0014Z",
  fill: "#2E2E2E"
});

var _ref221 = /*#__PURE__*/React.createElement("path", {
  d: "M145.826 88.3397C145.877 88.0709 145.886 87.7957 145.852 87.5243L144.248 74.7962L144.235 74.7004L144.233 74.7145L144.23 74.7004L144.217 74.7962L142.603 87.6119C142.576 87.8251 142.584 88.0415 142.628 88.2521L144.087 95.3238C144.132 95.5421 144.445 95.5399 144.487 95.321L145.826 88.3397Z",
  fill: "#2E2E2E"
});

var _ref222 = /*#__PURE__*/React.createElement("path", {
  d: "M147.019 70.8894C147.019 70.8894 147 70.9463 146.963 71.0458C146.714 71.7228 145.743 73.757 144.154 73.757C142.752 73.757 141.957 72.2629 141.711 71.2968C141.635 71.0056 141.602 70.8184 141.602 70.8184L141.869 68.8981L141.912 68.5999L141.931 68.4578L142.206 66.4924L142.208 66.4805L146.309 66.3455V66.3525L146.65 68.5215L146.673 68.6778L146.716 68.9431L147.019 70.8894Z",
  fill: "#FFC9A1"
});

var _ref223 = /*#__PURE__*/React.createElement("path", {
  d: "M146.674 68.6778C146.115 69.3454 145.346 69.8 144.285 69.8356C143.189 69.8734 142.433 69.3621 141.912 68.5996L141.931 68.4575L142.206 66.4921L142.208 66.4803L146.309 66.3452V66.3522L146.65 68.5212L146.674 68.6778Z",
  fill: "#F2BF99"
});

var _ref224 = /*#__PURE__*/React.createElement("path", {
  d: "M145.548 75.7458C145.729 75.5729 145.693 75.33 145.466 75.1881L144.294 74.4548H144.172L142.999 75.1881C142.773 75.33 142.737 75.5731 142.917 75.7458L144.139 76.9168H144.326L145.548 75.7458Z",
  fill: "#242424"
});

var _ref225 = /*#__PURE__*/React.createElement("path", {
  d: "M145.243 97.9204H142.75V98.8318H145.243V97.9204Z",
  fill: "#E6E3E3"
});

var _ref226 = /*#__PURE__*/React.createElement("path", {
  d: "M143.847 73.7397C143.331 74.0167 142.834 74.1919 142.457 74.5613C142.277 74.739 142.126 74.9591 142.012 75.2575C141.288 73.593 140.762 72.0302 140.636 70.6734C140.797 70.2282 140.925 69.9276 141.117 69.6529C141.288 69.4042 141.513 69.1769 141.856 68.8833C142.176 70.4129 142.768 71.9426 143.847 73.7397Z",
  fill: "#FAFAFA"
});

var _ref227 = /*#__PURE__*/React.createElement("path", {
  d: "M156.001 120.629C156.001 120.629 155.466 121.202 154.481 121.633C154.474 121.635 154.469 121.638 154.462 121.64C154.263 121.685 154.104 120.953 154.104 120.44C154.104 119.907 154.483 119.301 154.481 118.235C154.481 117.172 153.546 108.667 153.496 106.896C153.446 105.122 152.383 98.6416 152.331 97.73C152.281 96.8184 151.571 91.4008 151.443 90.1553L152.018 81.9343C152.021 81.9367 152.021 81.9367 152.021 81.9392L156.001 120.629Z",
  fill: "#EBEBEB"
});

var _ref228 = /*#__PURE__*/React.createElement("path", {
  d: "M154.482 94.3022C154.305 94.5554 153.216 96.7325 153.216 96.7325L151.444 94.4924L153.064 91.8721L154.482 94.3022Z",
  fill: "#FFC9A1"
});

var _ref229 = /*#__PURE__*/React.createElement("path", {
  d: "M147.458 70.4551L152.784 72.8946C153.513 73.2284 154.074 73.8445 154.34 74.601L158.202 85.6224C158.447 86.3204 158.42 87.0846 158.128 87.7639L154.684 95.7706L152.001 92.3276L153.95 86.52L150.861 81.9194L149.317 79.6191L147.458 70.4551Z",
  fill: "#FAFAFA"
});

var _ref230 = /*#__PURE__*/React.createElement("path", {
  d: "M150.439 93.231L153.259 96.7816L153.382 97.7301L150.002 93.3258L150.439 93.231Z",
  fill: "#EBEBEB"
});

var _ref231 = /*#__PURE__*/React.createElement("path", {
  d: "M149.749 93.8071C149.749 93.8071 148.863 96.6918 149.749 97.7304C150.635 98.769 152.382 99.25 152.382 99.25C152.382 99.25 149.873 99.0976 149.356 97.9206C148.838 96.7437 149.749 93.8071 149.749 93.8071Z",
  fill: "#EBEBEB"
});

var _ref232 = /*#__PURE__*/React.createElement("path", {
  d: "M138.413 94.2083C138.413 94.2083 139.299 97.093 138.413 98.1316C137.527 99.1701 135.781 99.6511 135.781 99.6511C135.781 99.6511 138.289 99.4987 138.807 98.3217C139.325 97.1448 138.413 94.2083 138.413 94.2083Z",
  fill: "#EBEBEB"
});

var _ref233 = /*#__PURE__*/React.createElement("path", {
  d: "M136.734 88.998C136.597 89.7958 135.383 101.062 135.307 101.294C135.231 101.528 134.293 115.046 133.983 117.326C133.725 119.223 133.637 120.781 133.832 121.565C132.946 121.143 132.465 120.63 132.465 120.63L136.24 83.9548C136.259 84.0824 136.872 88.2119 136.734 88.998Z",
  fill: "#EBEBEB"
});

var _ref234 = /*#__PURE__*/React.createElement("path", {
  d: "M133.983 94.3022C134.16 94.5554 135.249 96.7325 135.249 96.7325L137.021 94.4924L135.401 91.8721L133.983 94.3022Z",
  fill: "#FFC9A1"
});

var _ref235 = /*#__PURE__*/React.createElement("path", {
  d: "M141.007 70.4551L135.681 72.8946C134.952 73.2284 134.39 73.8445 134.125 74.601L130.262 85.6224C130.018 86.3204 130.044 87.0846 130.336 87.7639L133.781 95.7706L136.464 92.3276L134.515 86.52L139.147 79.6191C140.888 75.429 141.624 72.2573 141.007 70.4551Z",
  fill: "#FAFAFA"
});

var _ref236 = /*#__PURE__*/React.createElement("path", {
  d: "M137.723 93.6321L134.904 97.1824L134.781 98.1312L138.16 93.727L137.723 93.6321Z",
  fill: "#EBEBEB"
});

var _ref237 = /*#__PURE__*/React.createElement("path", {
  d: "M142.457 74.5613C142.277 74.739 142.126 74.9591 142.012 75.2575C141.288 73.593 140.762 72.0302 140.636 70.6734C140.797 70.2282 140.925 69.9276 141.117 69.6528C141.115 70.2614 141.056 71.1256 141.288 71.7579C141.614 72.6434 142.145 74.0854 142.348 74.3389C142.389 74.3885 142.424 74.4667 142.457 74.5613Z",
  fill: "#F2F2F2"
});

var _ref238 = /*#__PURE__*/React.createElement("path", {
  d: "M144.707 73.6321C145.223 73.909 145.721 74.0843 146.097 74.4537C146.277 74.6313 146.429 74.8514 146.542 75.1499C147.267 73.4854 147.793 71.9226 147.918 70.5657C147.757 70.1206 147.629 69.8199 147.437 69.5452C147.267 69.2966 147.042 69.0693 146.699 68.7756C146.379 70.3053 145.787 71.8349 144.707 73.6321Z",
  fill: "#FAFAFA"
});

var _ref239 = /*#__PURE__*/React.createElement("path", {
  d: "M146.098 74.4537C146.278 74.6313 146.429 74.8514 146.543 75.1499C147.267 73.4854 147.793 71.9225 147.919 70.5657C147.758 70.1206 147.63 69.8199 147.438 69.5452C147.44 70.1537 147.499 71.0179 147.267 71.6502C146.941 72.5357 146.41 73.9777 146.207 74.2312C146.166 74.2808 146.131 74.359 146.098 74.4537Z",
  fill: "#F2F2F2"
});

var _ref240 = /*#__PURE__*/React.createElement("path", {
  d: "M136.24 83.9519L136.47 79.3518C136.47 79.3518 137.549 84.38 137.021 85.0931C136.493 85.8062 136.56 87.8199 136.547 87.7691C136.534 87.7186 136.24 83.9519 136.24 83.9519Z",
  fill: "#EBEBEB"
});

var _ref241 = /*#__PURE__*/React.createElement("path", {
  d: "M140.64 61.739C140.64 61.739 140.072 68.9166 144.267 68.7736C148.759 68.6203 148.291 61.6136 148.291 61.6136L146.628 59.209C146.628 59.209 143.874 59.2351 143.763 59.3067C143.653 59.3783 142.248 60.5552 142.248 60.5552L140.64 61.739Z",
  fill: "#FFC9A1"
});

var _ref242 = /*#__PURE__*/React.createElement("path", {
  d: "M142.576 57.4907C142.576 57.4907 141.039 56.8101 139.697 59.1497C138.694 60.8962 139.506 61.7 139.351 62.462C139.197 63.2241 139.522 64.1588 139.903 64.7371C140.284 65.3153 141.118 65.838 141.118 65.838C141.118 65.838 140.534 63.8274 140.701 63.4196C140.868 63.0117 140.747 63.7567 142.885 63.5221C144.111 63.3877 145.148 62.7238 145.336 61.606C145.524 60.4881 145.659 61.2407 145.983 61.1309C146.625 60.9131 146.103 62.9041 146.997 63.2992C147.891 63.6943 147.81 63.9572 147.81 63.9572L147.861 65.5106C147.861 65.5106 149.626 63.5878 149.649 62.2628C149.671 60.9379 149.617 58.6929 147.843 57.6658C143.614 55.2168 142.576 57.4907 142.576 57.4907Z",
  fill: "#3D4456"
});

var _ref243 = /*#__PURE__*/React.createElement("path", {
  d: "M93.2603 108.139L94.182 112.479L93.9317 108.139H93.2603Z",
  fill: "#313645"
});

var SvgEmployees = function SvgEmployees(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 169,
    viewBox: "0 0 300 169",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132, _ref133, _ref134, _ref135, _ref136, _ref137, _ref138, _ref139, _ref140, _ref141, _ref142, _ref143, _ref144, _ref145, _ref146, _ref147, _ref148, _ref149, _ref150, _ref151, _ref152, _ref153, _ref154, _ref155, _ref156, _ref157, _ref158, _ref159, _ref160, _ref161, _ref162, _ref163, _ref164, _ref165, _ref166, _ref167, _ref168, _ref169, _ref170, _ref171, _ref172, _ref173, _ref174, _ref175, _ref176, _ref177, _ref178, _ref179, _ref180, _ref181, _ref182, _ref183, _ref184, _ref185, _ref186, _ref187, _ref188, _ref189, _ref190, _ref191, _ref192, _ref193, _ref194, _ref195, _ref196, _ref197, _ref198, _ref199, _ref200, _ref201, _ref202, _ref203, _ref204, _ref205, _ref206, _ref207, _ref208, _ref209, _ref210, _ref211, _ref212, _ref213, _ref214, _ref215, _ref216, _ref217, _ref218, _ref219, _ref220, _ref221, _ref222, _ref223, _ref224, _ref225, _ref226, _ref227, _ref228, _ref229, _ref230, _ref231, _ref232, _ref233, _ref234, _ref235, _ref236, _ref237, _ref238, _ref239, _ref240, _ref241, _ref242, _ref243);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmployees, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/employees.d75fa4a5.svg";
export { ForwardRef as ReactComponent };